/* tslint:disable */
/* eslint-disable */
/**
 * Doppio API
 * Microservice backend for ...
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ApplicationForm,
    ApplicationFormFromJSON,
    ApplicationFormToJSON,
    Claims,
    ClaimsFromJSON,
    ClaimsToJSON,
    ClaimsGroup,
    ClaimsGroupFromJSON,
    ClaimsGroupToJSON,
    ClaimsGroupLease,
    ClaimsGroupLeaseFromJSON,
    ClaimsGroupLeaseToJSON,
    ClaimsGroupLeaseback,
    ClaimsGroupLeasebackFromJSON,
    ClaimsGroupLeasebackToJSON,
    ClaimsSettings,
    ClaimsSettingsFromJSON,
    ClaimsSettingsToJSON,
    ClaimsStatement,
    ClaimsStatementFromJSON,
    ClaimsStatementToJSON,
    CreateClaimsStatement,
    CreateClaimsStatementFromJSON,
    CreateClaimsStatementToJSON,
    CreateDealRealtyGroup,
    CreateDealRealtyGroupFromJSON,
    CreateDealRealtyGroupToJSON,
    CreateObligation,
    CreateObligationFromJSON,
    CreateObligationToJSON,
    Deal,
    DealFromJSON,
    DealToJSON,
    DealBreach,
    DealBreachFromJSON,
    DealBreachToJSON,
    DealBreahSummary,
    DealBreahSummaryFromJSON,
    DealBreahSummaryToJSON,
    DealRealtyGroup,
    DealRealtyGroupFromJSON,
    DealRealtyGroupToJSON,
    DealRealtyGroupUpdate,
    DealRealtyGroupUpdateFromJSON,
    DealRealtyGroupUpdateToJSON,
    DealState,
    DealStateFromJSON,
    DealStateToJSON,
    ExportPaymentOrderSerilizer,
    ExportPaymentOrderSerilizerFromJSON,
    ExportPaymentOrderSerilizerToJSON,
    Label,
    LabelFromJSON,
    LabelToJSON,
    Note,
    NoteFromJSON,
    NoteToJSON,
    NoteAttributes,
    NoteAttributesFromJSON,
    NoteAttributesToJSON,
    NoticeGroup,
    NoticeGroupFromJSON,
    NoticeGroupToJSON,
    NoticeGroupUpdate,
    NoticeGroupUpdateFromJSON,
    NoticeGroupUpdateToJSON,
    Obligations,
    ObligationsFromJSON,
    ObligationsToJSON,
    Offers,
    OffersFromJSON,
    OffersToJSON,
    PaginatedDealsListList,
    PaginatedDealsListListFromJSON,
    PaginatedDealsListListToJSON,
    PaginatedPaymentList,
    PaginatedPaymentListFromJSON,
    PaginatedPaymentListToJSON,
    Participant,
    ParticipantFromJSON,
    ParticipantToJSON,
    PatchedClaims,
    PatchedClaimsFromJSON,
    PatchedClaimsToJSON,
    PatchedClaimsGroup,
    PatchedClaimsGroupFromJSON,
    PatchedClaimsGroupToJSON,
    PatchedClaimsGroupLease,
    PatchedClaimsGroupLeaseFromJSON,
    PatchedClaimsGroupLeaseToJSON,
    PatchedClaimsGroupLeaseback,
    PatchedClaimsGroupLeasebackFromJSON,
    PatchedClaimsGroupLeasebackToJSON,
    PatchedDeal,
    PatchedDealFromJSON,
    PatchedDealToJSON,
    PatchedDealRealtyGroupUpdate,
    PatchedDealRealtyGroupUpdateFromJSON,
    PatchedDealRealtyGroupUpdateToJSON,
    PatchedObligations,
    PatchedObligationsFromJSON,
    PatchedObligationsToJSON,
    PatchedParticipant,
    PatchedParticipantFromJSON,
    PatchedParticipantToJSON,
    PatchedPurpose,
    PatchedPurposeFromJSON,
    PatchedPurposeToJSON,
    PatchedPurposeDrawing,
    PatchedPurposeDrawingFromJSON,
    PatchedPurposeDrawingToJSON,
    PatchedUpdateClaimsStatement,
    PatchedUpdateClaimsStatementFromJSON,
    PatchedUpdateClaimsStatementToJSON,
    Purpose,
    PurposeFromJSON,
    PurposeToJSON,
    PurposeDrawing,
    PurposeDrawingFromJSON,
    PurposeDrawingToJSON,
    Realty,
    RealtyFromJSON,
    RealtyToJSON,
    SaveClaimsStatement,
    SaveClaimsStatementFromJSON,
    SaveClaimsStatementToJSON,
    StatesList,
    StatesListFromJSON,
    StatesListToJSON,
    UpdateClaimsStatement,
    UpdateClaimsStatementFromJSON,
    UpdateClaimsStatementToJSON,
    Validation,
    ValidationFromJSON,
    ValidationToJSON,
} from '../models';

export interface BreachRequest {
    id: number;
}

export interface BreachesTypeDistinctListRequest {
    dealId: string;
    ordering?: string;
    type?: Array<BreachesTypeDistinctListTypeEnum>;
}

export interface CreateClaimsRequest {
    dealId: string;
    claims: Claims;
}

export interface CreateClaimsGroupRequest {
    dealId: string;
    claimsGroup: ClaimsGroup;
}

export interface CreateClaimsGroupLeaseRequest {
    dealId: string;
    claimsGroupLease: ClaimsGroupLease;
}

export interface CreateClaimsGroupLeasebackRequest {
    dealId: string;
    claimsGroupLeaseback: ClaimsGroupLeaseback;
}

export interface CreateClaimsStatementRequest {
    dealId: string;
    createClaimsStatement: CreateClaimsStatement;
}

export interface CreateDealRequest {
    deal?: Deal;
}

export interface CreateDealNoteRequest {
    dealId: string;
    noteAttributes: NoteAttributes;
}

export interface CreateDealObligationsRequest {
    dealId: string;
    createObligation: CreateObligation;
}

export interface CreateDealParticipantRequest {
    dealId: string;
    participant: Participant;
}

export interface CreateDealPurposesRequest {
    dealId: string;
    purpose?: Purpose;
}

export interface CreateDealRealtyGroupRequest {
    dealId: string;
    createDealRealtyGroup: CreateDealRealtyGroup;
}

export interface CreateLabelRequest {
    dealId: string;
    label: Label;
}

export interface CreateNoticeGroupRequest {
    dealId: string;
    noticeGroup: NoticeGroup;
}

export interface CreateOfferRequest {
    id: number;
    offers?: Offers;
}

export interface CreateUpdateClaimsSettingsRequest {
    dealId: string;
    claimsSettings: ClaimsSettings;
}

export interface DealBreachesListRequest {
    dealId: string;
    ordering?: string;
    type?: Array<DealBreachesListTypeEnum>;
}

export interface DealBreachesSummaryRequest {
    dealId: string;
}

export interface DealStatesListRequest {
    id: number;
}

export interface DeleteClaimsRequest {
    dealId: string;
    id: number;
}

export interface DeleteClaimsGroupRequest {
    dealId: string;
    id: number;
}

export interface DeleteClaimsGroupLeaseRequest {
    dealId: string;
    id: number;
}

export interface DeleteClaimsGroupLeasebackRequest {
    dealId: string;
    id: number;
}

export interface DeleteDealObligationRequest {
    dealId: string;
    id: number;
}

export interface DeleteDealParticipantRequest {
    dealId: string;
    id: number;
}

export interface DeleteDealPurposesRequest {
    dealId: string;
    id: number;
}

export interface DeleteDealRealtyGroupRequest {
    dealId: string;
    id: number;
}

export interface DeleteLabelRequest {
    dealId: string;
    id: number;
}

export interface DeletePurposeDrawingRequest {
    id: number;
}

export interface DownloadDealPaymentsRequest {
    dealId: string;
}

export interface EvaluateNotificationRequest {
    dealId: string;
    id: number;
    dealRealtyGroup?: DealRealtyGroup;
}

export interface ExportClaimsRequest {
    dealId: string;
}

export interface ExportClaimsStatementRequest {
    allocationProfile: ExportClaimsStatementAllocationProfileEnum;
    dealId: string;
    id: number;
}

export interface ExportXmlPurposesPaymentsRequest {
    dealId: string;
    exportPaymentOrderSerilizer: Array<ExportPaymentOrderSerilizer>;
}

export interface GetApplicationFormRequest {
    id: number;
}

export interface GetClaimsStatementRequest {
    dealId: string;
    id: number;
}

export interface GetDealRequest {
    id: number;
    expand?: string;
}

export interface GetLabelRequest {
    dealId: string;
    id: number;
}

export interface GetObligationRequest {
    dealId: string;
    id: number;
}

export interface ListClaimsRequest {
    dealId: string;
    creditor?: any;
    dateFrom?: Date;
    dateTo?: Date;
    ordering?: string;
    type?: string;
}

export interface ListClaimsGroupLeaseRequest {
    dealId: string;
    ordering?: string;
}

export interface ListClaimsGroupLeasebackRequest {
    dealId: string;
    ordering?: string;
}

export interface ListClaimsGroupsRequest {
    dealId: string;
    ordering?: string;
}

export interface ListClaimsSettingsRequest {
    dealId: string;
    ordering?: string;
    type?: ListClaimsSettingsTypeEnum;
}

export interface ListClaimsStatementsRequest {
    dealId: string;
    ordering?: string;
    state?: ListClaimsStatementsStateEnum;
}

export interface ListDealNotesRequest {
    dealId: string;
    ordering?: string;
}

export interface ListDealObligationsRequest {
    dealId: string;
    ordering?: string;
}

export interface ListDealPaymentsRequest {
    dealId: string;
    dateFrom?: Date;
    dateTo?: Date;
    ordering?: string;
    page?: number;
    pageSize?: number;
    paymentType?: string;
    search?: string;
}

export interface ListDealPurposesRequest {
    dealId: string;
    ordering?: string;
}

export interface ListDealRealtiesRequest {
    dealId: string;
    ordering?: string;
}

export interface ListDealRealtyGroupsRequest {
    dealId: string;
    mortgage?: boolean;
    ordering?: string;
}

export interface ListDealsRequest {
    breachType?: Array<ListDealsBreachTypeEnum>;
    closedReason?: Array<ListDealsClosedReasonEnum>;
    daysPastDue?: number;
    externalId?: Array<number>;
    id?: number;
    insolvency?: boolean;
    liquidated?: boolean;
    ordering?: string;
    page?: number;
    pageSize?: number;
    search?: string;
    settingsOff?: Array<ListDealsSettingsOffEnum>;
    settingsOn?: Array<ListDealsSettingsOnEnum>;
    state?: Array<ListDealsStateEnum>;
    type?: Array<ListDealsTypeEnum>;
    valueFrom?: number;
    valueTo?: number;
}

export interface ListDealsParticipantsRequest {
    dealId: string;
    ordering?: string;
}

export interface ListLabelsRequest {
    dealId: string;
    ordering?: string;
}

export interface ListNoticeGroupsRequest {
    dealId: string;
    ordering?: string;
}

export interface PartialUpdateClaimsRequest {
    dealId: string;
    id: number;
    patchedClaims?: PatchedClaims;
}

export interface PartialUpdateClaimsGroupRequest {
    dealId: string;
    id: number;
    patchedClaimsGroup?: PatchedClaimsGroup;
}

export interface PartialUpdateClaimsGroupLeaseRequest {
    dealId: string;
    id: number;
    patchedClaimsGroupLease?: PatchedClaimsGroupLease;
}

export interface PartialUpdateClaimsGroupLeasebackRequest {
    dealId: string;
    id: number;
    patchedClaimsGroupLeaseback?: PatchedClaimsGroupLeaseback;
}

export interface PartialUpdateClaimsStatementRequest {
    dealId: string;
    id: number;
    patchedUpdateClaimsStatement?: PatchedUpdateClaimsStatement;
}

export interface PartialUpdateDealRequest {
    id: number;
    patchedDeal?: PatchedDeal;
}

export interface PartialUpdateDealParticipantRequest {
    dealId: string;
    id: number;
    patchedParticipant?: PatchedParticipant;
}

export interface PartialUpdateDealPurposesRequest {
    dealId: string;
    id: number;
    patchedPurpose?: PatchedPurpose;
}

export interface PartialUpdateDealRealtyGroupRequest {
    dealId: string;
    id: number;
    patchedDealRealtyGroupUpdate?: PatchedDealRealtyGroupUpdate;
}

export interface PartialUpdateObligationRequest {
    dealId: string;
    id: number;
    patchedObligations?: PatchedObligations;
}

export interface PartialUpdatePurposeDrawingRequest {
    id: number;
    patchedPurposeDrawing?: PatchedPurposeDrawing;
}

export interface SaveClaimsStatementRequest {
    dealId: string;
    id: number;
    saveClaimsStatement?: SaveClaimsStatement;
}

export interface SendNoticesRequest {
    dealId: string;
    id: number;
    noticeGroup: NoticeGroup;
}

export interface UpdateClaimsRequest {
    dealId: string;
    id: number;
    claims: Claims;
}

export interface UpdateClaimsGroupRequest {
    dealId: string;
    id: number;
    claimsGroup: ClaimsGroup;
}

export interface UpdateClaimsGroupLeaseRequest {
    dealId: string;
    id: number;
    claimsGroupLease: ClaimsGroupLease;
}

export interface UpdateClaimsGroupLeasebackRequest {
    dealId: string;
    id: number;
    claimsGroupLeaseback: ClaimsGroupLeaseback;
}

export interface UpdateClaimsStatementRequest {
    dealId: string;
    id: number;
    updateClaimsStatement?: UpdateClaimsStatement;
}

export interface UpdateDealRequest {
    id: number;
    deal?: Deal;
}

export interface UpdateDealParticipantRequest {
    dealId: string;
    id: number;
    participant: Participant;
}

export interface UpdateDealPurposesRequest {
    dealId: string;
    id: number;
    purpose?: Purpose;
}

export interface UpdateDealRealtyGroupRequest {
    dealId: string;
    id: number;
    dealRealtyGroupUpdate?: DealRealtyGroupUpdate;
}

export interface UpdateDealStateRequest {
    id: number;
    dealState: DealState;
}

export interface UpdateNoticeGroupRequest {
    dealId: string;
    id: number;
    noticeGroupUpdate: NoticeGroupUpdate;
}

export interface UpdateObligationRequest {
    dealId: string;
    id: number;
    obligations?: Obligations;
}

export interface ValidateRequest {
    id: number;
}

/**
 * DealsApi - interface
 * 
 * @export
 * @interface DealsApiInterface
 */
export interface DealsApiInterface {
    /**
     * 
     * @param {number} id A unique integer value identifying this base deal.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApiInterface
     */
    breachRaw(requestParameters: BreachRequest): Promise<runtime.ApiResponse<DealBreach>>;

    /**
     */
    breach(requestParameters: BreachRequest): Promise<DealBreach>;

    /**
     * In app, we have manually created NoticeGroup on some deals. Every NoticeGroup has to be bound to a Breach. User can select one of the breaches from this list to connect to a NoticeGroup.
     * @param {string} dealId 
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {Array<'NON_PAYING' | 'UNDELIVERED_BLOCKAGE_AGREEMENT' | 'UNDELIVERED_NOTARIAL_DEED'>} [type] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApiInterface
     */
    breachesTypeDistinctListRaw(requestParameters: BreachesTypeDistinctListRequest): Promise<runtime.ApiResponse<Array<DealBreach>>>;

    /**
     * In app, we have manually created NoticeGroup on some deals. Every NoticeGroup has to be bound to a Breach. User can select one of the breaches from this list to connect to a NoticeGroup.
     */
    breachesTypeDistinctList(requestParameters: BreachesTypeDistinctListRequest): Promise<Array<DealBreach>>;

    /**
     * 
     * @param {string} dealId 
     * @param {Claims} claims 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApiInterface
     */
    createClaimsRaw(requestParameters: CreateClaimsRequest): Promise<runtime.ApiResponse<Claims>>;

    /**
     */
    createClaims(requestParameters: CreateClaimsRequest): Promise<Claims>;

    /**
     * 
     * @param {string} dealId 
     * @param {ClaimsGroup} claimsGroup 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApiInterface
     */
    createClaimsGroupRaw(requestParameters: CreateClaimsGroupRequest): Promise<runtime.ApiResponse<ClaimsGroup>>;

    /**
     */
    createClaimsGroup(requestParameters: CreateClaimsGroupRequest): Promise<ClaimsGroup>;

    /**
     * 
     * @param {string} dealId 
     * @param {ClaimsGroupLease} claimsGroupLease 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApiInterface
     */
    createClaimsGroupLeaseRaw(requestParameters: CreateClaimsGroupLeaseRequest): Promise<runtime.ApiResponse<ClaimsGroupLease>>;

    /**
     */
    createClaimsGroupLease(requestParameters: CreateClaimsGroupLeaseRequest): Promise<ClaimsGroupLease>;

    /**
     * 
     * @param {string} dealId 
     * @param {ClaimsGroupLeaseback} claimsGroupLeaseback 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApiInterface
     */
    createClaimsGroupLeasebackRaw(requestParameters: CreateClaimsGroupLeasebackRequest): Promise<runtime.ApiResponse<ClaimsGroupLeaseback>>;

    /**
     */
    createClaimsGroupLeaseback(requestParameters: CreateClaimsGroupLeasebackRequest): Promise<ClaimsGroupLeaseback>;

    /**
     * 
     * @param {string} dealId 
     * @param {CreateClaimsStatement} createClaimsStatement 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApiInterface
     */
    createClaimsStatementRaw(requestParameters: CreateClaimsStatementRequest): Promise<runtime.ApiResponse<ClaimsStatement>>;

    /**
     */
    createClaimsStatement(requestParameters: CreateClaimsStatementRequest): Promise<ClaimsStatement>;

    /**
     * 
     * @param {Deal} [deal] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApiInterface
     */
    createDealRaw(requestParameters: CreateDealRequest): Promise<runtime.ApiResponse<Deal>>;

    /**
     */
    createDeal(requestParameters: CreateDealRequest): Promise<Deal>;

    /**
     * 
     * @param {string} dealId 
     * @param {NoteAttributes} noteAttributes 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApiInterface
     */
    createDealNoteRaw(requestParameters: CreateDealNoteRequest): Promise<runtime.ApiResponse<Note>>;

    /**
     */
    createDealNote(requestParameters: CreateDealNoteRequest): Promise<Note>;

    /**
     * 
     * @param {string} dealId 
     * @param {CreateObligation} createObligation 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApiInterface
     */
    createDealObligationsRaw(requestParameters: CreateDealObligationsRequest): Promise<runtime.ApiResponse<CreateObligation>>;

    /**
     */
    createDealObligations(requestParameters: CreateDealObligationsRequest): Promise<CreateObligation>;

    /**
     * 
     * @param {string} dealId 
     * @param {Participant} participant 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApiInterface
     */
    createDealParticipantRaw(requestParameters: CreateDealParticipantRequest): Promise<runtime.ApiResponse<void>>;

    /**
     */
    createDealParticipant(requestParameters: CreateDealParticipantRequest): Promise<void>;

    /**
     * 
     * @param {string} dealId 
     * @param {Purpose} [purpose] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApiInterface
     */
    createDealPurposesRaw(requestParameters: CreateDealPurposesRequest): Promise<runtime.ApiResponse<Purpose>>;

    /**
     */
    createDealPurposes(requestParameters: CreateDealPurposesRequest): Promise<Purpose>;

    /**
     * 
     * @param {string} dealId 
     * @param {CreateDealRealtyGroup} createDealRealtyGroup 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApiInterface
     */
    createDealRealtyGroupRaw(requestParameters: CreateDealRealtyGroupRequest): Promise<runtime.ApiResponse<CreateDealRealtyGroup>>;

    /**
     */
    createDealRealtyGroup(requestParameters: CreateDealRealtyGroupRequest): Promise<CreateDealRealtyGroup>;

    /**
     * 
     * @param {string} dealId 
     * @param {Label} label 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApiInterface
     */
    createLabelRaw(requestParameters: CreateLabelRequest): Promise<runtime.ApiResponse<Label>>;

    /**
     */
    createLabel(requestParameters: CreateLabelRequest): Promise<Label>;

    /**
     * 
     * @param {string} dealId 
     * @param {NoticeGroup} noticeGroup 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApiInterface
     */
    createNoticeGroupRaw(requestParameters: CreateNoticeGroupRequest): Promise<runtime.ApiResponse<NoticeGroup>>;

    /**
     */
    createNoticeGroup(requestParameters: CreateNoticeGroupRequest): Promise<NoticeGroup>;

    /**
     * This method return lead and form objects data. But, because we can find Form object in database only based on deal object primary key we have to add this method into DealViewSet in order to properly generation of OpenAPI schema.
     * @param {number} id A unique integer value identifying this base deal.
     * @param {Offers} [offers] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApiInterface
     */
    createOfferRaw(requestParameters: CreateOfferRequest): Promise<runtime.ApiResponse<Offers>>;

    /**
     * This method return lead and form objects data. But, because we can find Form object in database only based on deal object primary key we have to add this method into DealViewSet in order to properly generation of OpenAPI schema.
     */
    createOffer(requestParameters: CreateOfferRequest): Promise<Offers>;

    /**
     * 
     * @param {string} dealId 
     * @param {ClaimsSettings} claimsSettings 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApiInterface
     */
    createUpdateClaimsSettingsRaw(requestParameters: CreateUpdateClaimsSettingsRequest): Promise<runtime.ApiResponse<ClaimsSettings>>;

    /**
     */
    createUpdateClaimsSettings(requestParameters: CreateUpdateClaimsSettingsRequest): Promise<ClaimsSettings>;

    /**
     * 
     * @param {string} dealId 
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {Array<'NON_PAYING' | 'UNDELIVERED_BLOCKAGE_AGREEMENT' | 'UNDELIVERED_NOTARIAL_DEED'>} [type] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApiInterface
     */
    dealBreachesListRaw(requestParameters: DealBreachesListRequest): Promise<runtime.ApiResponse<Array<DealBreach>>>;

    /**
     */
    dealBreachesList(requestParameters: DealBreachesListRequest): Promise<Array<DealBreach>>;

    /**
     * 
     * @param {string} dealId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApiInterface
     */
    dealBreachesSummaryRaw(requestParameters: DealBreachesSummaryRequest): Promise<runtime.ApiResponse<DealBreahSummary>>;

    /**
     */
    dealBreachesSummary(requestParameters: DealBreachesSummaryRequest): Promise<DealBreahSummary>;

    /**
     * 
     * @param {number} id A unique integer value identifying this base deal.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApiInterface
     */
    dealStatesListRaw(requestParameters: DealStatesListRequest): Promise<runtime.ApiResponse<StatesList>>;

    /**
     */
    dealStatesList(requestParameters: DealStatesListRequest): Promise<StatesList>;

    /**
     * 
     * @param {string} dealId 
     * @param {number} id A unique integer value identifying this static claim.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApiInterface
     */
    deleteClaimsRaw(requestParameters: DeleteClaimsRequest): Promise<runtime.ApiResponse<void>>;

    /**
     */
    deleteClaims(requestParameters: DeleteClaimsRequest): Promise<void>;

    /**
     * 
     * @param {string} dealId 
     * @param {number} id A unique integer value identifying this claims group.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApiInterface
     */
    deleteClaimsGroupRaw(requestParameters: DeleteClaimsGroupRequest): Promise<runtime.ApiResponse<void>>;

    /**
     */
    deleteClaimsGroup(requestParameters: DeleteClaimsGroupRequest): Promise<void>;

    /**
     * 
     * @param {string} dealId 
     * @param {number} id A unique integer value identifying this claims group lease.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApiInterface
     */
    deleteClaimsGroupLeaseRaw(requestParameters: DeleteClaimsGroupLeaseRequest): Promise<runtime.ApiResponse<void>>;

    /**
     */
    deleteClaimsGroupLease(requestParameters: DeleteClaimsGroupLeaseRequest): Promise<void>;

    /**
     * 
     * @param {string} dealId 
     * @param {number} id A unique integer value identifying this claims group leaseback.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApiInterface
     */
    deleteClaimsGroupLeasebackRaw(requestParameters: DeleteClaimsGroupLeasebackRequest): Promise<runtime.ApiResponse<void>>;

    /**
     */
    deleteClaimsGroupLeaseback(requestParameters: DeleteClaimsGroupLeasebackRequest): Promise<void>;

    /**
     * 
     * @param {string} dealId 
     * @param {number} id A unique integer value identifying this obligation.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApiInterface
     */
    deleteDealObligationRaw(requestParameters: DeleteDealObligationRequest): Promise<runtime.ApiResponse<void>>;

    /**
     */
    deleteDealObligation(requestParameters: DeleteDealObligationRequest): Promise<void>;

    /**
     * 
     * @param {string} dealId 
     * @param {number} id A unique integer value identifying this participant.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApiInterface
     */
    deleteDealParticipantRaw(requestParameters: DeleteDealParticipantRequest): Promise<runtime.ApiResponse<void>>;

    /**
     */
    deleteDealParticipant(requestParameters: DeleteDealParticipantRequest): Promise<void>;

    /**
     * 
     * @param {string} dealId 
     * @param {number} id A unique integer value identifying this purpose.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApiInterface
     */
    deleteDealPurposesRaw(requestParameters: DeleteDealPurposesRequest): Promise<runtime.ApiResponse<void>>;

    /**
     */
    deleteDealPurposes(requestParameters: DeleteDealPurposesRequest): Promise<void>;

    /**
     * Calling this endpoint deletes Deal Realty Group
     * @param {string} dealId 
     * @param {number} id A unique integer value identifying this base deal.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApiInterface
     */
    deleteDealRealtyGroupRaw(requestParameters: DeleteDealRealtyGroupRequest): Promise<runtime.ApiResponse<void>>;

    /**
     * Calling this endpoint deletes Deal Realty Group
     */
    deleteDealRealtyGroup(requestParameters: DeleteDealRealtyGroupRequest): Promise<void>;

    /**
     * 
     * @param {string} dealId 
     * @param {number} id A unique integer value identifying this label.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApiInterface
     */
    deleteLabelRaw(requestParameters: DeleteLabelRequest): Promise<runtime.ApiResponse<void>>;

    /**
     */
    deleteLabel(requestParameters: DeleteLabelRequest): Promise<void>;

    /**
     * 
     * @param {number} id A unique integer value identifying this purpose drawing.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApiInterface
     */
    deletePurposeDrawingRaw(requestParameters: DeletePurposeDrawingRequest): Promise<runtime.ApiResponse<void>>;

    /**
     */
    deletePurposeDrawing(requestParameters: DeletePurposeDrawingRequest): Promise<void>;

    /**
     * 
     * @param {string} dealId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApiInterface
     */
    downloadDealPaymentsRaw(requestParameters: DownloadDealPaymentsRequest): Promise<runtime.ApiResponse<Blob>>;

    /**
     */
    downloadDealPayments(requestParameters: DownloadDealPaymentsRequest): Promise<Blob>;

    /**
     * This endpoint creates notification for Analytics Department with request evaluate Deal Realty Group
     * @param {string} dealId 
     * @param {number} id A unique integer value identifying this base deal.
     * @param {DealRealtyGroup} [dealRealtyGroup] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApiInterface
     */
    evaluateNotificationRaw(requestParameters: EvaluateNotificationRequest): Promise<runtime.ApiResponse<void>>;

    /**
     * This endpoint creates notification for Analytics Department with request evaluate Deal Realty Group
     */
    evaluateNotification(requestParameters: EvaluateNotificationRequest): Promise<void>;

    /**
     * Create XLSX document containing all of the deal claims
     * @param {string} dealId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApiInterface
     */
    exportClaimsRaw(requestParameters: ExportClaimsRequest): Promise<runtime.ApiResponse<Blob>>;

    /**
     * Create XLSX document containing all of the deal claims
     */
    exportClaims(requestParameters: ExportClaimsRequest): Promise<Blob>;

    /**
     * Create XLSX document containing data about claims statement for given date
     * @param {'CL_PE_ALLOCATION_PROFILE_V1' | 'CL_PE_ALLOCATION_PROFILE_V2' | 'IL_SE_ALLOCATION_PROFILE' | 'LOAN_ALLOCATION_PROFILE_V1' | 'LOAN_ALLOCATION_PROFILE_V2' | 'OTHER_PROFILE_V1'} allocationProfile 
     * @param {string} dealId 
     * @param {number} id A unique integer value identifying this claims statement.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApiInterface
     */
    exportClaimsStatementRaw(requestParameters: ExportClaimsStatementRequest): Promise<runtime.ApiResponse<Blob>>;

    /**
     * Create XLSX document containing data about claims statement for given date
     */
    exportClaimsStatement(requestParameters: ExportClaimsStatementRequest): Promise<Blob>;

    /**
     * Create XML file. File contents payment orders generated from Purposes objects.
     * @param {string} dealId 
     * @param {Array<ExportPaymentOrderSerilizer>} exportPaymentOrderSerilizer 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApiInterface
     */
    exportXmlPurposesPaymentsRaw(requestParameters: ExportXmlPurposesPaymentsRequest): Promise<runtime.ApiResponse<Blob>>;

    /**
     * Create XML file. File contents payment orders generated from Purposes objects.
     */
    exportXmlPurposesPayments(requestParameters: ExportXmlPurposesPaymentsRequest): Promise<Blob>;

    /**
     * This method return lead and form objects data. But, because we can find Form object in database only based on deal object primary key we have to add this method into DealViewSet in order to properly generation of OpenAPI schema.
     * @param {number} id A unique integer value identifying this base deal.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApiInterface
     */
    getApplicationFormRaw(requestParameters: GetApplicationFormRequest): Promise<runtime.ApiResponse<ApplicationForm>>;

    /**
     * This method return lead and form objects data. But, because we can find Form object in database only based on deal object primary key we have to add this method into DealViewSet in order to properly generation of OpenAPI schema.
     */
    getApplicationForm(requestParameters: GetApplicationFormRequest): Promise<ApplicationForm>;

    /**
     * 
     * @param {string} dealId 
     * @param {number} id A unique integer value identifying this claims statement.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApiInterface
     */
    getClaimsStatementRaw(requestParameters: GetClaimsStatementRequest): Promise<runtime.ApiResponse<ClaimsStatement>>;

    /**
     */
    getClaimsStatement(requestParameters: GetClaimsStatementRequest): Promise<ClaimsStatement>;

    /**
     * 
     * @param {number} id A unique integer value identifying this base deal.
     * @param {string} [expand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApiInterface
     */
    getDealRaw(requestParameters: GetDealRequest): Promise<runtime.ApiResponse<Deal>>;

    /**
     */
    getDeal(requestParameters: GetDealRequest): Promise<Deal>;

    /**
     * 
     * @param {string} dealId 
     * @param {number} id A unique integer value identifying this label.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApiInterface
     */
    getLabelRaw(requestParameters: GetLabelRequest): Promise<runtime.ApiResponse<Label>>;

    /**
     */
    getLabel(requestParameters: GetLabelRequest): Promise<Label>;

    /**
     * 
     * @param {string} dealId 
     * @param {number} id A unique integer value identifying this obligation.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApiInterface
     */
    getObligationRaw(requestParameters: GetObligationRequest): Promise<runtime.ApiResponse<Obligations>>;

    /**
     */
    getObligation(requestParameters: GetObligationRequest): Promise<Obligations>;

    /**
     * 
     * @param {string} dealId 
     * @param {any} [creditor] 
     * @param {Date} [dateFrom] 
     * @param {Date} [dateTo] 
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {string} [type] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApiInterface
     */
    listClaimsRaw(requestParameters: ListClaimsRequest): Promise<runtime.ApiResponse<Array<Claims>>>;

    /**
     */
    listClaims(requestParameters: ListClaimsRequest): Promise<Array<Claims>>;

    /**
     * 
     * @param {string} dealId 
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApiInterface
     */
    listClaimsGroupLeaseRaw(requestParameters: ListClaimsGroupLeaseRequest): Promise<runtime.ApiResponse<Array<ClaimsGroupLease>>>;

    /**
     */
    listClaimsGroupLease(requestParameters: ListClaimsGroupLeaseRequest): Promise<Array<ClaimsGroupLease>>;

    /**
     * 
     * @param {string} dealId 
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApiInterface
     */
    listClaimsGroupLeasebackRaw(requestParameters: ListClaimsGroupLeasebackRequest): Promise<runtime.ApiResponse<Array<ClaimsGroupLeaseback>>>;

    /**
     */
    listClaimsGroupLeaseback(requestParameters: ListClaimsGroupLeasebackRequest): Promise<Array<ClaimsGroupLeaseback>>;

    /**
     * 
     * @param {string} dealId 
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApiInterface
     */
    listClaimsGroupsRaw(requestParameters: ListClaimsGroupsRequest): Promise<runtime.ApiResponse<Array<ClaimsGroup>>>;

    /**
     */
    listClaimsGroups(requestParameters: ListClaimsGroupsRequest): Promise<Array<ClaimsGroup>>;

    /**
     * 
     * @param {string} dealId 
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {'DISABLE_BLOCKAGE_AGREEMENT_NOTICE' | 'DISABLE_NON_PAYING_NOTICE' | 'DISABLE_NOTARIAL_DEED_NOTICE'} [type] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApiInterface
     */
    listClaimsSettingsRaw(requestParameters: ListClaimsSettingsRequest): Promise<runtime.ApiResponse<Array<ClaimsSettings>>>;

    /**
     */
    listClaimsSettings(requestParameters: ListClaimsSettingsRequest): Promise<Array<ClaimsSettings>>;

    /**
     * 
     * @param {string} dealId 
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {'DRAFT' | 'IN_PROGRESS' | 'NOT_VALID' | 'SAVED'} [state] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApiInterface
     */
    listClaimsStatementsRaw(requestParameters: ListClaimsStatementsRequest): Promise<runtime.ApiResponse<Array<ClaimsStatement>>>;

    /**
     */
    listClaimsStatements(requestParameters: ListClaimsStatementsRequest): Promise<Array<ClaimsStatement>>;

    /**
     * Get list of notes for appropriate deal
     * @param {string} dealId 
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApiInterface
     */
    listDealNotesRaw(requestParameters: ListDealNotesRequest): Promise<runtime.ApiResponse<Array<Note>>>;

    /**
     * Get list of notes for appropriate deal
     */
    listDealNotes(requestParameters: ListDealNotesRequest): Promise<Array<Note>>;

    /**
     * 
     * @param {string} dealId 
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApiInterface
     */
    listDealObligationsRaw(requestParameters: ListDealObligationsRequest): Promise<runtime.ApiResponse<Array<Obligations>>>;

    /**
     */
    listDealObligations(requestParameters: ListDealObligationsRequest): Promise<Array<Obligations>>;

    /**
     * 
     * @param {string} dealId 
     * @param {Date} [dateFrom] 
     * @param {Date} [dateTo] 
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [pageSize] Number of results to return per page.
     * @param {string} [paymentType] 
     * @param {string} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApiInterface
     */
    listDealPaymentsRaw(requestParameters: ListDealPaymentsRequest): Promise<runtime.ApiResponse<PaginatedPaymentList>>;

    /**
     */
    listDealPayments(requestParameters: ListDealPaymentsRequest): Promise<PaginatedPaymentList>;

    /**
     * 
     * @param {string} dealId 
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApiInterface
     */
    listDealPurposesRaw(requestParameters: ListDealPurposesRequest): Promise<runtime.ApiResponse<Array<Purpose>>>;

    /**
     */
    listDealPurposes(requestParameters: ListDealPurposesRequest): Promise<Array<Purpose>>;

    /**
     * 
     * @param {string} dealId 
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApiInterface
     */
    listDealRealtiesRaw(requestParameters: ListDealRealtiesRequest): Promise<runtime.ApiResponse<Array<Realty>>>;

    /**
     */
    listDealRealties(requestParameters: ListDealRealtiesRequest): Promise<Array<Realty>>;

    /**
     * 
     * @param {string} dealId 
     * @param {boolean} [mortgage] 
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApiInterface
     */
    listDealRealtyGroupsRaw(requestParameters: ListDealRealtyGroupsRequest): Promise<runtime.ApiResponse<Array<DealRealtyGroup>>>;

    /**
     */
    listDealRealtyGroups(requestParameters: ListDealRealtyGroupsRequest): Promise<Array<DealRealtyGroup>>;

    /**
     * 
     * @param {Array<'NON_PAYING' | 'UNDELIVERED_BLOCKAGE_AGREEMENT' | 'UNDELIVERED_INCOME_TAX_EVIDENCE' | 'UNDELIVERED_NOTARIAL_DEED' | 'UNDELIVERED_OTHER_DOCUMENTS' | 'UNDELIVERED_THIRD_PARTY_EVIDENCE'>} [breachType] 
     * @param {Array<'CLOSED_AFTER_INSOLVENCY' | 'CLOSED_AFTER_LIQUIDATION' | 'CLOSED_DEAL_WRITE_OFF' | 'CLOSED_DEBTOR_DEATH_NO_SUCCESOR' | 'CLOSED_DULY' | 'CLOSED_ENFORCEMENT' | 'CLOSED_LEASE_FINISHED' | 'CLOSED_LEASE_FORCED_EVICTION' | 'CLOSED_MOVED_TO_HC' | 'CLOSED_MOVED_TO_THIRD_PARTY' | 'CLOSED_PREMATURELY' | 'CLOSED_PROPERTY_NOT_PURCHASED' | 'CLOSED_PROPERTY_PURCHASED' | 'CLOSED_PROPERTY_SOLD' | 'CLOSED_REFINANCED' | 'OTHER'>} [closedReason] 
     * @param {number} [daysPastDue] 
     * @param {Array<number>} [externalId] Více hodnot lze oddělit čárkami.
     * @param {number} [id] 
     * @param {boolean} [insolvency] 
     * @param {boolean} [liquidated] 
     * @param {string} [ordering] 
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [pageSize] Number of results to return per page.
     * @param {string} [search] A search term.
     * @param {Array<'DISABLE_BLOCKAGE_AGREEMENT_NOTICE' | 'DISABLE_NON_PAYING_NOTICE' | 'DISABLE_NOTARIAL_DEED_NOTICE'>} [settingsOff] 
     * @param {Array<'DISABLE_BLOCKAGE_AGREEMENT_NOTICE' | 'DISABLE_NON_PAYING_NOTICE' | 'DISABLE_NOTARIAL_DEED_NOTICE'>} [settingsOn] 
     * @param {Array<'ACTIVE' | 'CLOSED' | 'CLOSED_APPLICATION' | 'CONTRACT_COMPLETION' | 'CONTRACT_SIGN' | 'FILED_FOR_INSOLVENCY' | 'NEW_APPLICATION'>} [state] 
     * @param {Array<'BORROWING' | 'CONSUMER_LOAN' | 'INVESTMENT_LOAN' | 'LEASE' | 'LEASING' | 'OTHER_DEAL' | 'SALE' | 'SALE_AND_LEASEBACK'>} [type] 
     * @param {number} [valueFrom] 
     * @param {number} [valueTo] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApiInterface
     */
    listDealsRaw(requestParameters: ListDealsRequest): Promise<runtime.ApiResponse<PaginatedDealsListList>>;

    /**
     */
    listDeals(requestParameters: ListDealsRequest): Promise<PaginatedDealsListList>;

    /**
     * 
     * @param {string} dealId 
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApiInterface
     */
    listDealsParticipantsRaw(requestParameters: ListDealsParticipantsRequest): Promise<runtime.ApiResponse<Array<Participant>>>;

    /**
     */
    listDealsParticipants(requestParameters: ListDealsParticipantsRequest): Promise<Array<Participant>>;

    /**
     * 
     * @param {string} dealId 
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApiInterface
     */
    listLabelsRaw(requestParameters: ListLabelsRequest): Promise<runtime.ApiResponse<Array<Label>>>;

    /**
     */
    listLabels(requestParameters: ListLabelsRequest): Promise<Array<Label>>;

    /**
     * 
     * @param {string} dealId 
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApiInterface
     */
    listNoticeGroupsRaw(requestParameters: ListNoticeGroupsRequest): Promise<runtime.ApiResponse<Array<NoticeGroup>>>;

    /**
     */
    listNoticeGroups(requestParameters: ListNoticeGroupsRequest): Promise<Array<NoticeGroup>>;

    /**
     * 
     * @param {string} dealId 
     * @param {number} id A unique integer value identifying this static claim.
     * @param {PatchedClaims} [patchedClaims] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApiInterface
     */
    partialUpdateClaimsRaw(requestParameters: PartialUpdateClaimsRequest): Promise<runtime.ApiResponse<Claims>>;

    /**
     */
    partialUpdateClaims(requestParameters: PartialUpdateClaimsRequest): Promise<Claims>;

    /**
     * 
     * @param {string} dealId 
     * @param {number} id A unique integer value identifying this claims group.
     * @param {PatchedClaimsGroup} [patchedClaimsGroup] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApiInterface
     */
    partialUpdateClaimsGroupRaw(requestParameters: PartialUpdateClaimsGroupRequest): Promise<runtime.ApiResponse<ClaimsGroup>>;

    /**
     */
    partialUpdateClaimsGroup(requestParameters: PartialUpdateClaimsGroupRequest): Promise<ClaimsGroup>;

    /**
     * 
     * @param {string} dealId 
     * @param {number} id A unique integer value identifying this claims group lease.
     * @param {PatchedClaimsGroupLease} [patchedClaimsGroupLease] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApiInterface
     */
    partialUpdateClaimsGroupLeaseRaw(requestParameters: PartialUpdateClaimsGroupLeaseRequest): Promise<runtime.ApiResponse<ClaimsGroupLease>>;

    /**
     */
    partialUpdateClaimsGroupLease(requestParameters: PartialUpdateClaimsGroupLeaseRequest): Promise<ClaimsGroupLease>;

    /**
     * 
     * @param {string} dealId 
     * @param {number} id A unique integer value identifying this claims group leaseback.
     * @param {PatchedClaimsGroupLeaseback} [patchedClaimsGroupLeaseback] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApiInterface
     */
    partialUpdateClaimsGroupLeasebackRaw(requestParameters: PartialUpdateClaimsGroupLeasebackRequest): Promise<runtime.ApiResponse<ClaimsGroupLeaseback>>;

    /**
     */
    partialUpdateClaimsGroupLeaseback(requestParameters: PartialUpdateClaimsGroupLeasebackRequest): Promise<ClaimsGroupLeaseback>;

    /**
     * 
     * @param {string} dealId 
     * @param {number} id A unique integer value identifying this claims statement.
     * @param {PatchedUpdateClaimsStatement} [patchedUpdateClaimsStatement] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApiInterface
     */
    partialUpdateClaimsStatementRaw(requestParameters: PartialUpdateClaimsStatementRequest): Promise<runtime.ApiResponse<ClaimsStatement>>;

    /**
     */
    partialUpdateClaimsStatement(requestParameters: PartialUpdateClaimsStatementRequest): Promise<ClaimsStatement>;

    /**
     * 
     * @param {number} id A unique integer value identifying this base deal.
     * @param {PatchedDeal} [patchedDeal] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApiInterface
     */
    partialUpdateDealRaw(requestParameters: PartialUpdateDealRequest): Promise<runtime.ApiResponse<Deal>>;

    /**
     */
    partialUpdateDeal(requestParameters: PartialUpdateDealRequest): Promise<Deal>;

    /**
     * 
     * @param {string} dealId 
     * @param {number} id A unique integer value identifying this participant.
     * @param {PatchedParticipant} [patchedParticipant] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApiInterface
     */
    partialUpdateDealParticipantRaw(requestParameters: PartialUpdateDealParticipantRequest): Promise<runtime.ApiResponse<void>>;

    /**
     */
    partialUpdateDealParticipant(requestParameters: PartialUpdateDealParticipantRequest): Promise<void>;

    /**
     * 
     * @param {string} dealId 
     * @param {number} id A unique integer value identifying this purpose.
     * @param {PatchedPurpose} [patchedPurpose] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApiInterface
     */
    partialUpdateDealPurposesRaw(requestParameters: PartialUpdateDealPurposesRequest): Promise<runtime.ApiResponse<Purpose>>;

    /**
     */
    partialUpdateDealPurposes(requestParameters: PartialUpdateDealPurposesRequest): Promise<Purpose>;

    /**
     * 
     * @param {string} dealId 
     * @param {number} id A unique integer value identifying this base deal.
     * @param {PatchedDealRealtyGroupUpdate} [patchedDealRealtyGroupUpdate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApiInterface
     */
    partialUpdateDealRealtyGroupRaw(requestParameters: PartialUpdateDealRealtyGroupRequest): Promise<runtime.ApiResponse<DealRealtyGroupUpdate>>;

    /**
     */
    partialUpdateDealRealtyGroup(requestParameters: PartialUpdateDealRealtyGroupRequest): Promise<DealRealtyGroupUpdate>;

    /**
     * 
     * @param {string} dealId 
     * @param {number} id A unique integer value identifying this obligation.
     * @param {PatchedObligations} [patchedObligations] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApiInterface
     */
    partialUpdateObligationRaw(requestParameters: PartialUpdateObligationRequest): Promise<runtime.ApiResponse<Obligations>>;

    /**
     */
    partialUpdateObligation(requestParameters: PartialUpdateObligationRequest): Promise<Obligations>;

    /**
     * 
     * @param {number} id A unique integer value identifying this purpose drawing.
     * @param {PatchedPurposeDrawing} [patchedPurposeDrawing] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApiInterface
     */
    partialUpdatePurposeDrawingRaw(requestParameters: PartialUpdatePurposeDrawingRequest): Promise<runtime.ApiResponse<PurposeDrawing>>;

    /**
     */
    partialUpdatePurposeDrawing(requestParameters: PartialUpdatePurposeDrawingRequest): Promise<PurposeDrawing>;

    /**
     * 
     * @param {string} dealId 
     * @param {number} id A unique integer value identifying this claims statement.
     * @param {SaveClaimsStatement} [saveClaimsStatement] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApiInterface
     */
    saveClaimsStatementRaw(requestParameters: SaveClaimsStatementRequest): Promise<runtime.ApiResponse<ClaimsStatement>>;

    /**
     */
    saveClaimsStatement(requestParameters: SaveClaimsStatementRequest): Promise<ClaimsStatement>;

    /**
     * 
     * @param {string} dealId 
     * @param {number} id A unique integer value identifying this notice group.
     * @param {NoticeGroup} noticeGroup 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApiInterface
     */
    sendNoticesRaw(requestParameters: SendNoticesRequest): Promise<runtime.ApiResponse<void>>;

    /**
     */
    sendNotices(requestParameters: SendNoticesRequest): Promise<void>;

    /**
     * 
     * @param {string} dealId 
     * @param {number} id A unique integer value identifying this static claim.
     * @param {Claims} claims 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApiInterface
     */
    updateClaimsRaw(requestParameters: UpdateClaimsRequest): Promise<runtime.ApiResponse<Claims>>;

    /**
     */
    updateClaims(requestParameters: UpdateClaimsRequest): Promise<Claims>;

    /**
     * 
     * @param {string} dealId 
     * @param {number} id A unique integer value identifying this claims group.
     * @param {ClaimsGroup} claimsGroup 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApiInterface
     */
    updateClaimsGroupRaw(requestParameters: UpdateClaimsGroupRequest): Promise<runtime.ApiResponse<ClaimsGroup>>;

    /**
     */
    updateClaimsGroup(requestParameters: UpdateClaimsGroupRequest): Promise<ClaimsGroup>;

    /**
     * 
     * @param {string} dealId 
     * @param {number} id A unique integer value identifying this claims group lease.
     * @param {ClaimsGroupLease} claimsGroupLease 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApiInterface
     */
    updateClaimsGroupLeaseRaw(requestParameters: UpdateClaimsGroupLeaseRequest): Promise<runtime.ApiResponse<ClaimsGroupLease>>;

    /**
     */
    updateClaimsGroupLease(requestParameters: UpdateClaimsGroupLeaseRequest): Promise<ClaimsGroupLease>;

    /**
     * 
     * @param {string} dealId 
     * @param {number} id A unique integer value identifying this claims group leaseback.
     * @param {ClaimsGroupLeaseback} claimsGroupLeaseback 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApiInterface
     */
    updateClaimsGroupLeasebackRaw(requestParameters: UpdateClaimsGroupLeasebackRequest): Promise<runtime.ApiResponse<ClaimsGroupLeaseback>>;

    /**
     */
    updateClaimsGroupLeaseback(requestParameters: UpdateClaimsGroupLeasebackRequest): Promise<ClaimsGroupLeaseback>;

    /**
     * 
     * @param {string} dealId 
     * @param {number} id A unique integer value identifying this claims statement.
     * @param {UpdateClaimsStatement} [updateClaimsStatement] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApiInterface
     */
    updateClaimsStatementRaw(requestParameters: UpdateClaimsStatementRequest): Promise<runtime.ApiResponse<ClaimsStatement>>;

    /**
     */
    updateClaimsStatement(requestParameters: UpdateClaimsStatementRequest): Promise<ClaimsStatement>;

    /**
     * 
     * @param {number} id A unique integer value identifying this base deal.
     * @param {Deal} [deal] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApiInterface
     */
    updateDealRaw(requestParameters: UpdateDealRequest): Promise<runtime.ApiResponse<Deal>>;

    /**
     */
    updateDeal(requestParameters: UpdateDealRequest): Promise<Deal>;

    /**
     * 
     * @param {string} dealId 
     * @param {number} id A unique integer value identifying this participant.
     * @param {Participant} participant 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApiInterface
     */
    updateDealParticipantRaw(requestParameters: UpdateDealParticipantRequest): Promise<runtime.ApiResponse<void>>;

    /**
     */
    updateDealParticipant(requestParameters: UpdateDealParticipantRequest): Promise<void>;

    /**
     * 
     * @param {string} dealId 
     * @param {number} id A unique integer value identifying this purpose.
     * @param {Purpose} [purpose] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApiInterface
     */
    updateDealPurposesRaw(requestParameters: UpdateDealPurposesRequest): Promise<runtime.ApiResponse<Purpose>>;

    /**
     */
    updateDealPurposes(requestParameters: UpdateDealPurposesRequest): Promise<Purpose>;

    /**
     * 
     * @param {string} dealId 
     * @param {number} id A unique integer value identifying this base deal.
     * @param {DealRealtyGroupUpdate} [dealRealtyGroupUpdate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApiInterface
     */
    updateDealRealtyGroupRaw(requestParameters: UpdateDealRealtyGroupRequest): Promise<runtime.ApiResponse<DealRealtyGroupUpdate>>;

    /**
     */
    updateDealRealtyGroup(requestParameters: UpdateDealRealtyGroupRequest): Promise<DealRealtyGroupUpdate>;

    /**
     * attributes \"closed_application_reason\" and \"additional_data\": {\"closed_application_notification\": true/false} are required for \"CLOSED_APPLICATION\" state and deal types \"CONSUMER_LOAN\" and \"INVESTMENT_LOAN\", otherwise it is ignored.
     * @summary Request for deal state change.
     * @param {number} id A unique integer value identifying this base deal.
     * @param {DealState} dealState 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApiInterface
     */
    updateDealStateRaw(requestParameters: UpdateDealStateRequest): Promise<runtime.ApiResponse<void>>;

    /**
     * attributes \"closed_application_reason\" and \"additional_data\": {\"closed_application_notification\": true/false} are required for \"CLOSED_APPLICATION\" state and deal types \"CONSUMER_LOAN\" and \"INVESTMENT_LOAN\", otherwise it is ignored.
     * Request for deal state change.
     */
    updateDealState(requestParameters: UpdateDealStateRequest): Promise<void>;

    /**
     * 
     * @param {string} dealId 
     * @param {number} id A unique integer value identifying this notice group.
     * @param {NoticeGroupUpdate} noticeGroupUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApiInterface
     */
    updateNoticeGroupRaw(requestParameters: UpdateNoticeGroupRequest): Promise<runtime.ApiResponse<NoticeGroupUpdate>>;

    /**
     */
    updateNoticeGroup(requestParameters: UpdateNoticeGroupRequest): Promise<NoticeGroupUpdate>;

    /**
     * 
     * @param {string} dealId 
     * @param {number} id A unique integer value identifying this obligation.
     * @param {Obligations} [obligations] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApiInterface
     */
    updateObligationRaw(requestParameters: UpdateObligationRequest): Promise<runtime.ApiResponse<Obligations>>;

    /**
     */
    updateObligation(requestParameters: UpdateObligationRequest): Promise<Obligations>;

    /**
     * 
     * @param {number} id A unique integer value identifying this base deal.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealsApiInterface
     */
    validateRaw(requestParameters: ValidateRequest): Promise<runtime.ApiResponse<Validation>>;

    /**
     */
    validate(requestParameters: ValidateRequest): Promise<Validation>;

}

/**
 * 
 */
export class DealsApi extends runtime.BaseAPI implements DealsApiInterface {

    /**
     */
    async breachRaw(requestParameters: BreachRequest): Promise<runtime.ApiResponse<DealBreach>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling breach.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/deals/{id}/breach/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => DealBreachFromJSON(jsonValue));
    }

    /**
     */
    async breach(requestParameters: BreachRequest): Promise<DealBreach> {
        const response = await this.breachRaw(requestParameters);
        return await response.value();
    }

    /**
     * In app, we have manually created NoticeGroup on some deals. Every NoticeGroup has to be bound to a Breach. User can select one of the breaches from this list to connect to a NoticeGroup.
     */
    async breachesTypeDistinctListRaw(requestParameters: BreachesTypeDistinctListRequest): Promise<runtime.ApiResponse<Array<DealBreach>>> {
        if (requestParameters.dealId === null || requestParameters.dealId === undefined) {
            throw new runtime.RequiredError('dealId','Required parameter requestParameters.dealId was null or undefined when calling breachesTypeDistinctList.');
        }

        const queryParameters: any = {};

        if (requestParameters.ordering !== undefined) {
            queryParameters['ordering'] = requestParameters.ordering;
        }

        if (requestParameters.type) {
            queryParameters['type'] = requestParameters.type;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/deals/{dealId}/breaches/breachesTypeDistinctList/`.replace(`{${"dealId"}}`, encodeURIComponent(String(requestParameters.dealId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DealBreachFromJSON));
    }

    /**
     * In app, we have manually created NoticeGroup on some deals. Every NoticeGroup has to be bound to a Breach. User can select one of the breaches from this list to connect to a NoticeGroup.
     */
    async breachesTypeDistinctList(requestParameters: BreachesTypeDistinctListRequest): Promise<Array<DealBreach>> {
        const response = await this.breachesTypeDistinctListRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async createClaimsRaw(requestParameters: CreateClaimsRequest): Promise<runtime.ApiResponse<Claims>> {
        if (requestParameters.dealId === null || requestParameters.dealId === undefined) {
            throw new runtime.RequiredError('dealId','Required parameter requestParameters.dealId was null or undefined when calling createClaims.');
        }

        if (requestParameters.claims === null || requestParameters.claims === undefined) {
            throw new runtime.RequiredError('claims','Required parameter requestParameters.claims was null or undefined when calling createClaims.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/deals/{dealId}/claims/`.replace(`{${"dealId"}}`, encodeURIComponent(String(requestParameters.dealId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ClaimsToJSON(requestParameters.claims),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimsFromJSON(jsonValue));
    }

    /**
     */
    async createClaims(requestParameters: CreateClaimsRequest): Promise<Claims> {
        const response = await this.createClaimsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async createClaimsGroupRaw(requestParameters: CreateClaimsGroupRequest): Promise<runtime.ApiResponse<ClaimsGroup>> {
        if (requestParameters.dealId === null || requestParameters.dealId === undefined) {
            throw new runtime.RequiredError('dealId','Required parameter requestParameters.dealId was null or undefined when calling createClaimsGroup.');
        }

        if (requestParameters.claimsGroup === null || requestParameters.claimsGroup === undefined) {
            throw new runtime.RequiredError('claimsGroup','Required parameter requestParameters.claimsGroup was null or undefined when calling createClaimsGroup.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/deals/{dealId}/claims-group/`.replace(`{${"dealId"}}`, encodeURIComponent(String(requestParameters.dealId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ClaimsGroupToJSON(requestParameters.claimsGroup),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimsGroupFromJSON(jsonValue));
    }

    /**
     */
    async createClaimsGroup(requestParameters: CreateClaimsGroupRequest): Promise<ClaimsGroup> {
        const response = await this.createClaimsGroupRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async createClaimsGroupLeaseRaw(requestParameters: CreateClaimsGroupLeaseRequest): Promise<runtime.ApiResponse<ClaimsGroupLease>> {
        if (requestParameters.dealId === null || requestParameters.dealId === undefined) {
            throw new runtime.RequiredError('dealId','Required parameter requestParameters.dealId was null or undefined when calling createClaimsGroupLease.');
        }

        if (requestParameters.claimsGroupLease === null || requestParameters.claimsGroupLease === undefined) {
            throw new runtime.RequiredError('claimsGroupLease','Required parameter requestParameters.claimsGroupLease was null or undefined when calling createClaimsGroupLease.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/deals/{dealId}/claims-group-lease/`.replace(`{${"dealId"}}`, encodeURIComponent(String(requestParameters.dealId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ClaimsGroupLeaseToJSON(requestParameters.claimsGroupLease),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimsGroupLeaseFromJSON(jsonValue));
    }

    /**
     */
    async createClaimsGroupLease(requestParameters: CreateClaimsGroupLeaseRequest): Promise<ClaimsGroupLease> {
        const response = await this.createClaimsGroupLeaseRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async createClaimsGroupLeasebackRaw(requestParameters: CreateClaimsGroupLeasebackRequest): Promise<runtime.ApiResponse<ClaimsGroupLeaseback>> {
        if (requestParameters.dealId === null || requestParameters.dealId === undefined) {
            throw new runtime.RequiredError('dealId','Required parameter requestParameters.dealId was null or undefined when calling createClaimsGroupLeaseback.');
        }

        if (requestParameters.claimsGroupLeaseback === null || requestParameters.claimsGroupLeaseback === undefined) {
            throw new runtime.RequiredError('claimsGroupLeaseback','Required parameter requestParameters.claimsGroupLeaseback was null or undefined when calling createClaimsGroupLeaseback.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/deals/{dealId}/claims-group-leaseback/`.replace(`{${"dealId"}}`, encodeURIComponent(String(requestParameters.dealId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ClaimsGroupLeasebackToJSON(requestParameters.claimsGroupLeaseback),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimsGroupLeasebackFromJSON(jsonValue));
    }

    /**
     */
    async createClaimsGroupLeaseback(requestParameters: CreateClaimsGroupLeasebackRequest): Promise<ClaimsGroupLeaseback> {
        const response = await this.createClaimsGroupLeasebackRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async createClaimsStatementRaw(requestParameters: CreateClaimsStatementRequest): Promise<runtime.ApiResponse<ClaimsStatement>> {
        if (requestParameters.dealId === null || requestParameters.dealId === undefined) {
            throw new runtime.RequiredError('dealId','Required parameter requestParameters.dealId was null or undefined when calling createClaimsStatement.');
        }

        if (requestParameters.createClaimsStatement === null || requestParameters.createClaimsStatement === undefined) {
            throw new runtime.RequiredError('createClaimsStatement','Required parameter requestParameters.createClaimsStatement was null or undefined when calling createClaimsStatement.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/deals/{dealId}/claims-statements/`.replace(`{${"dealId"}}`, encodeURIComponent(String(requestParameters.dealId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateClaimsStatementToJSON(requestParameters.createClaimsStatement),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimsStatementFromJSON(jsonValue));
    }

    /**
     */
    async createClaimsStatement(requestParameters: CreateClaimsStatementRequest): Promise<ClaimsStatement> {
        const response = await this.createClaimsStatementRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async createDealRaw(requestParameters: CreateDealRequest): Promise<runtime.ApiResponse<Deal>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/deals/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DealToJSON(requestParameters.deal),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => DealFromJSON(jsonValue));
    }

    /**
     */
    async createDeal(requestParameters: CreateDealRequest): Promise<Deal> {
        const response = await this.createDealRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async createDealNoteRaw(requestParameters: CreateDealNoteRequest): Promise<runtime.ApiResponse<Note>> {
        if (requestParameters.dealId === null || requestParameters.dealId === undefined) {
            throw new runtime.RequiredError('dealId','Required parameter requestParameters.dealId was null or undefined when calling createDealNote.');
        }

        if (requestParameters.noteAttributes === null || requestParameters.noteAttributes === undefined) {
            throw new runtime.RequiredError('noteAttributes','Required parameter requestParameters.noteAttributes was null or undefined when calling createDealNote.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/deals/{dealId}/notes/`.replace(`{${"dealId"}}`, encodeURIComponent(String(requestParameters.dealId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NoteAttributesToJSON(requestParameters.noteAttributes),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => NoteFromJSON(jsonValue));
    }

    /**
     */
    async createDealNote(requestParameters: CreateDealNoteRequest): Promise<Note> {
        const response = await this.createDealNoteRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async createDealObligationsRaw(requestParameters: CreateDealObligationsRequest): Promise<runtime.ApiResponse<CreateObligation>> {
        if (requestParameters.dealId === null || requestParameters.dealId === undefined) {
            throw new runtime.RequiredError('dealId','Required parameter requestParameters.dealId was null or undefined when calling createDealObligations.');
        }

        if (requestParameters.createObligation === null || requestParameters.createObligation === undefined) {
            throw new runtime.RequiredError('createObligation','Required parameter requestParameters.createObligation was null or undefined when calling createDealObligations.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/deals/{dealId}/obligations/`.replace(`{${"dealId"}}`, encodeURIComponent(String(requestParameters.dealId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateObligationToJSON(requestParameters.createObligation),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateObligationFromJSON(jsonValue));
    }

    /**
     */
    async createDealObligations(requestParameters: CreateDealObligationsRequest): Promise<CreateObligation> {
        const response = await this.createDealObligationsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async createDealParticipantRaw(requestParameters: CreateDealParticipantRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.dealId === null || requestParameters.dealId === undefined) {
            throw new runtime.RequiredError('dealId','Required parameter requestParameters.dealId was null or undefined when calling createDealParticipant.');
        }

        if (requestParameters.participant === null || requestParameters.participant === undefined) {
            throw new runtime.RequiredError('participant','Required parameter requestParameters.participant was null or undefined when calling createDealParticipant.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/deals/{dealId}/participants/`.replace(`{${"dealId"}}`, encodeURIComponent(String(requestParameters.dealId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ParticipantToJSON(requestParameters.participant),
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async createDealParticipant(requestParameters: CreateDealParticipantRequest): Promise<void> {
        await this.createDealParticipantRaw(requestParameters);
    }

    /**
     */
    async createDealPurposesRaw(requestParameters: CreateDealPurposesRequest): Promise<runtime.ApiResponse<Purpose>> {
        if (requestParameters.dealId === null || requestParameters.dealId === undefined) {
            throw new runtime.RequiredError('dealId','Required parameter requestParameters.dealId was null or undefined when calling createDealPurposes.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/deals/{dealId}/purposes/`.replace(`{${"dealId"}}`, encodeURIComponent(String(requestParameters.dealId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PurposeToJSON(requestParameters.purpose),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => PurposeFromJSON(jsonValue));
    }

    /**
     */
    async createDealPurposes(requestParameters: CreateDealPurposesRequest): Promise<Purpose> {
        const response = await this.createDealPurposesRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async createDealRealtyGroupRaw(requestParameters: CreateDealRealtyGroupRequest): Promise<runtime.ApiResponse<CreateDealRealtyGroup>> {
        if (requestParameters.dealId === null || requestParameters.dealId === undefined) {
            throw new runtime.RequiredError('dealId','Required parameter requestParameters.dealId was null or undefined when calling createDealRealtyGroup.');
        }

        if (requestParameters.createDealRealtyGroup === null || requestParameters.createDealRealtyGroup === undefined) {
            throw new runtime.RequiredError('createDealRealtyGroup','Required parameter requestParameters.createDealRealtyGroup was null or undefined when calling createDealRealtyGroup.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/deals/{dealId}/realty-groups/`.replace(`{${"dealId"}}`, encodeURIComponent(String(requestParameters.dealId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateDealRealtyGroupToJSON(requestParameters.createDealRealtyGroup),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateDealRealtyGroupFromJSON(jsonValue));
    }

    /**
     */
    async createDealRealtyGroup(requestParameters: CreateDealRealtyGroupRequest): Promise<CreateDealRealtyGroup> {
        const response = await this.createDealRealtyGroupRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async createLabelRaw(requestParameters: CreateLabelRequest): Promise<runtime.ApiResponse<Label>> {
        if (requestParameters.dealId === null || requestParameters.dealId === undefined) {
            throw new runtime.RequiredError('dealId','Required parameter requestParameters.dealId was null or undefined when calling createLabel.');
        }

        if (requestParameters.label === null || requestParameters.label === undefined) {
            throw new runtime.RequiredError('label','Required parameter requestParameters.label was null or undefined when calling createLabel.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/deals/{dealId}/label/`.replace(`{${"dealId"}}`, encodeURIComponent(String(requestParameters.dealId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: LabelToJSON(requestParameters.label),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => LabelFromJSON(jsonValue));
    }

    /**
     */
    async createLabel(requestParameters: CreateLabelRequest): Promise<Label> {
        const response = await this.createLabelRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async createNoticeGroupRaw(requestParameters: CreateNoticeGroupRequest): Promise<runtime.ApiResponse<NoticeGroup>> {
        if (requestParameters.dealId === null || requestParameters.dealId === undefined) {
            throw new runtime.RequiredError('dealId','Required parameter requestParameters.dealId was null or undefined when calling createNoticeGroup.');
        }

        if (requestParameters.noticeGroup === null || requestParameters.noticeGroup === undefined) {
            throw new runtime.RequiredError('noticeGroup','Required parameter requestParameters.noticeGroup was null or undefined when calling createNoticeGroup.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/deals/{dealId}/notice-groups/`.replace(`{${"dealId"}}`, encodeURIComponent(String(requestParameters.dealId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NoticeGroupToJSON(requestParameters.noticeGroup),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => NoticeGroupFromJSON(jsonValue));
    }

    /**
     */
    async createNoticeGroup(requestParameters: CreateNoticeGroupRequest): Promise<NoticeGroup> {
        const response = await this.createNoticeGroupRaw(requestParameters);
        return await response.value();
    }

    /**
     * This method return lead and form objects data. But, because we can find Form object in database only based on deal object primary key we have to add this method into DealViewSet in order to properly generation of OpenAPI schema.
     */
    async createOfferRaw(requestParameters: CreateOfferRequest): Promise<runtime.ApiResponse<Offers>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling createOffer.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/deals/{id}/offer/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OffersToJSON(requestParameters.offers),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => OffersFromJSON(jsonValue));
    }

    /**
     * This method return lead and form objects data. But, because we can find Form object in database only based on deal object primary key we have to add this method into DealViewSet in order to properly generation of OpenAPI schema.
     */
    async createOffer(requestParameters: CreateOfferRequest): Promise<Offers> {
        const response = await this.createOfferRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async createUpdateClaimsSettingsRaw(requestParameters: CreateUpdateClaimsSettingsRequest): Promise<runtime.ApiResponse<ClaimsSettings>> {
        if (requestParameters.dealId === null || requestParameters.dealId === undefined) {
            throw new runtime.RequiredError('dealId','Required parameter requestParameters.dealId was null or undefined when calling createUpdateClaimsSettings.');
        }

        if (requestParameters.claimsSettings === null || requestParameters.claimsSettings === undefined) {
            throw new runtime.RequiredError('claimsSettings','Required parameter requestParameters.claimsSettings was null or undefined when calling createUpdateClaimsSettings.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/deals/{dealId}/claims-settings/update-create/`.replace(`{${"dealId"}}`, encodeURIComponent(String(requestParameters.dealId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ClaimsSettingsToJSON(requestParameters.claimsSettings),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimsSettingsFromJSON(jsonValue));
    }

    /**
     */
    async createUpdateClaimsSettings(requestParameters: CreateUpdateClaimsSettingsRequest): Promise<ClaimsSettings> {
        const response = await this.createUpdateClaimsSettingsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async dealBreachesListRaw(requestParameters: DealBreachesListRequest): Promise<runtime.ApiResponse<Array<DealBreach>>> {
        if (requestParameters.dealId === null || requestParameters.dealId === undefined) {
            throw new runtime.RequiredError('dealId','Required parameter requestParameters.dealId was null or undefined when calling dealBreachesList.');
        }

        const queryParameters: any = {};

        if (requestParameters.ordering !== undefined) {
            queryParameters['ordering'] = requestParameters.ordering;
        }

        if (requestParameters.type) {
            queryParameters['type'] = requestParameters.type;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/deals/{dealId}/breaches/`.replace(`{${"dealId"}}`, encodeURIComponent(String(requestParameters.dealId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DealBreachFromJSON));
    }

    /**
     */
    async dealBreachesList(requestParameters: DealBreachesListRequest): Promise<Array<DealBreach>> {
        const response = await this.dealBreachesListRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async dealBreachesSummaryRaw(requestParameters: DealBreachesSummaryRequest): Promise<runtime.ApiResponse<DealBreahSummary>> {
        if (requestParameters.dealId === null || requestParameters.dealId === undefined) {
            throw new runtime.RequiredError('dealId','Required parameter requestParameters.dealId was null or undefined when calling dealBreachesSummary.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/deals/{dealId}/breaches/summary/`.replace(`{${"dealId"}}`, encodeURIComponent(String(requestParameters.dealId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => DealBreahSummaryFromJSON(jsonValue));
    }

    /**
     */
    async dealBreachesSummary(requestParameters: DealBreachesSummaryRequest): Promise<DealBreahSummary> {
        const response = await this.dealBreachesSummaryRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async dealStatesListRaw(requestParameters: DealStatesListRequest): Promise<runtime.ApiResponse<StatesList>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling dealStatesList.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/deals/{id}/states/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => StatesListFromJSON(jsonValue));
    }

    /**
     */
    async dealStatesList(requestParameters: DealStatesListRequest): Promise<StatesList> {
        const response = await this.dealStatesListRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async deleteClaimsRaw(requestParameters: DeleteClaimsRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.dealId === null || requestParameters.dealId === undefined) {
            throw new runtime.RequiredError('dealId','Required parameter requestParameters.dealId was null or undefined when calling deleteClaims.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteClaims.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/deals/{dealId}/claims/{id}/`.replace(`{${"dealId"}}`, encodeURIComponent(String(requestParameters.dealId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteClaims(requestParameters: DeleteClaimsRequest): Promise<void> {
        await this.deleteClaimsRaw(requestParameters);
    }

    /**
     */
    async deleteClaimsGroupRaw(requestParameters: DeleteClaimsGroupRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.dealId === null || requestParameters.dealId === undefined) {
            throw new runtime.RequiredError('dealId','Required parameter requestParameters.dealId was null or undefined when calling deleteClaimsGroup.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteClaimsGroup.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/deals/{dealId}/claims-group/{id}/`.replace(`{${"dealId"}}`, encodeURIComponent(String(requestParameters.dealId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteClaimsGroup(requestParameters: DeleteClaimsGroupRequest): Promise<void> {
        await this.deleteClaimsGroupRaw(requestParameters);
    }

    /**
     */
    async deleteClaimsGroupLeaseRaw(requestParameters: DeleteClaimsGroupLeaseRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.dealId === null || requestParameters.dealId === undefined) {
            throw new runtime.RequiredError('dealId','Required parameter requestParameters.dealId was null or undefined when calling deleteClaimsGroupLease.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteClaimsGroupLease.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/deals/{dealId}/claims-group-lease/{id}/`.replace(`{${"dealId"}}`, encodeURIComponent(String(requestParameters.dealId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteClaimsGroupLease(requestParameters: DeleteClaimsGroupLeaseRequest): Promise<void> {
        await this.deleteClaimsGroupLeaseRaw(requestParameters);
    }

    /**
     */
    async deleteClaimsGroupLeasebackRaw(requestParameters: DeleteClaimsGroupLeasebackRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.dealId === null || requestParameters.dealId === undefined) {
            throw new runtime.RequiredError('dealId','Required parameter requestParameters.dealId was null or undefined when calling deleteClaimsGroupLeaseback.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteClaimsGroupLeaseback.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/deals/{dealId}/claims-group-leaseback/{id}/`.replace(`{${"dealId"}}`, encodeURIComponent(String(requestParameters.dealId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteClaimsGroupLeaseback(requestParameters: DeleteClaimsGroupLeasebackRequest): Promise<void> {
        await this.deleteClaimsGroupLeasebackRaw(requestParameters);
    }

    /**
     */
    async deleteDealObligationRaw(requestParameters: DeleteDealObligationRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.dealId === null || requestParameters.dealId === undefined) {
            throw new runtime.RequiredError('dealId','Required parameter requestParameters.dealId was null or undefined when calling deleteDealObligation.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteDealObligation.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/deals/{dealId}/obligations/{id}/`.replace(`{${"dealId"}}`, encodeURIComponent(String(requestParameters.dealId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteDealObligation(requestParameters: DeleteDealObligationRequest): Promise<void> {
        await this.deleteDealObligationRaw(requestParameters);
    }

    /**
     */
    async deleteDealParticipantRaw(requestParameters: DeleteDealParticipantRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.dealId === null || requestParameters.dealId === undefined) {
            throw new runtime.RequiredError('dealId','Required parameter requestParameters.dealId was null or undefined when calling deleteDealParticipant.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteDealParticipant.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/deals/{dealId}/participants/{id}/`.replace(`{${"dealId"}}`, encodeURIComponent(String(requestParameters.dealId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteDealParticipant(requestParameters: DeleteDealParticipantRequest): Promise<void> {
        await this.deleteDealParticipantRaw(requestParameters);
    }

    /**
     */
    async deleteDealPurposesRaw(requestParameters: DeleteDealPurposesRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.dealId === null || requestParameters.dealId === undefined) {
            throw new runtime.RequiredError('dealId','Required parameter requestParameters.dealId was null or undefined when calling deleteDealPurposes.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteDealPurposes.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/deals/{dealId}/purposes/{id}/`.replace(`{${"dealId"}}`, encodeURIComponent(String(requestParameters.dealId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteDealPurposes(requestParameters: DeleteDealPurposesRequest): Promise<void> {
        await this.deleteDealPurposesRaw(requestParameters);
    }

    /**
     * Calling this endpoint deletes Deal Realty Group
     */
    async deleteDealRealtyGroupRaw(requestParameters: DeleteDealRealtyGroupRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.dealId === null || requestParameters.dealId === undefined) {
            throw new runtime.RequiredError('dealId','Required parameter requestParameters.dealId was null or undefined when calling deleteDealRealtyGroup.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteDealRealtyGroup.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/deals/{dealId}/realty-groups/{id}/`.replace(`{${"dealId"}}`, encodeURIComponent(String(requestParameters.dealId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Calling this endpoint deletes Deal Realty Group
     */
    async deleteDealRealtyGroup(requestParameters: DeleteDealRealtyGroupRequest): Promise<void> {
        await this.deleteDealRealtyGroupRaw(requestParameters);
    }

    /**
     */
    async deleteLabelRaw(requestParameters: DeleteLabelRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.dealId === null || requestParameters.dealId === undefined) {
            throw new runtime.RequiredError('dealId','Required parameter requestParameters.dealId was null or undefined when calling deleteLabel.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteLabel.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/deals/{dealId}/label/{id}/`.replace(`{${"dealId"}}`, encodeURIComponent(String(requestParameters.dealId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteLabel(requestParameters: DeleteLabelRequest): Promise<void> {
        await this.deleteLabelRaw(requestParameters);
    }

    /**
     */
    async deletePurposeDrawingRaw(requestParameters: DeletePurposeDrawingRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deletePurposeDrawing.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/deals/purpose/purpose-drawing/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deletePurposeDrawing(requestParameters: DeletePurposeDrawingRequest): Promise<void> {
        await this.deletePurposeDrawingRaw(requestParameters);
    }

    /**
     */
    async downloadDealPaymentsRaw(requestParameters: DownloadDealPaymentsRequest): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.dealId === null || requestParameters.dealId === undefined) {
            throw new runtime.RequiredError('dealId','Required parameter requestParameters.dealId was null or undefined when calling downloadDealPayments.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/deals/{dealId}/payments/download/`.replace(`{${"dealId"}}`, encodeURIComponent(String(requestParameters.dealId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.BlobApiResponse(response);
    }

    /**
     */
    async downloadDealPayments(requestParameters: DownloadDealPaymentsRequest): Promise<Blob> {
        const response = await this.downloadDealPaymentsRaw(requestParameters);
        return await response.value();
    }

    /**
     * This endpoint creates notification for Analytics Department with request evaluate Deal Realty Group
     */
    async evaluateNotificationRaw(requestParameters: EvaluateNotificationRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.dealId === null || requestParameters.dealId === undefined) {
            throw new runtime.RequiredError('dealId','Required parameter requestParameters.dealId was null or undefined when calling evaluateNotification.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling evaluateNotification.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/deals/{dealId}/realty-groups/{id}/evaluate_notification/`.replace(`{${"dealId"}}`, encodeURIComponent(String(requestParameters.dealId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DealRealtyGroupToJSON(requestParameters.dealRealtyGroup),
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     * This endpoint creates notification for Analytics Department with request evaluate Deal Realty Group
     */
    async evaluateNotification(requestParameters: EvaluateNotificationRequest): Promise<void> {
        await this.evaluateNotificationRaw(requestParameters);
    }

    /**
     * Create XLSX document containing all of the deal claims
     */
    async exportClaimsRaw(requestParameters: ExportClaimsRequest): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.dealId === null || requestParameters.dealId === undefined) {
            throw new runtime.RequiredError('dealId','Required parameter requestParameters.dealId was null or undefined when calling exportClaims.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/deals/{dealId}/claims/export/`.replace(`{${"dealId"}}`, encodeURIComponent(String(requestParameters.dealId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Create XLSX document containing all of the deal claims
     */
    async exportClaims(requestParameters: ExportClaimsRequest): Promise<Blob> {
        const response = await this.exportClaimsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create XLSX document containing data about claims statement for given date
     */
    async exportClaimsStatementRaw(requestParameters: ExportClaimsStatementRequest): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.allocationProfile === null || requestParameters.allocationProfile === undefined) {
            throw new runtime.RequiredError('allocationProfile','Required parameter requestParameters.allocationProfile was null or undefined when calling exportClaimsStatement.');
        }

        if (requestParameters.dealId === null || requestParameters.dealId === undefined) {
            throw new runtime.RequiredError('dealId','Required parameter requestParameters.dealId was null or undefined when calling exportClaimsStatement.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling exportClaimsStatement.');
        }

        const queryParameters: any = {};

        if (requestParameters.allocationProfile !== undefined) {
            queryParameters['allocation_profile'] = requestParameters.allocationProfile;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/deals/{dealId}/claims-statements/{id}/export/`.replace(`{${"dealId"}}`, encodeURIComponent(String(requestParameters.dealId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Create XLSX document containing data about claims statement for given date
     */
    async exportClaimsStatement(requestParameters: ExportClaimsStatementRequest): Promise<Blob> {
        const response = await this.exportClaimsStatementRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create XML file. File contents payment orders generated from Purposes objects.
     */
    async exportXmlPurposesPaymentsRaw(requestParameters: ExportXmlPurposesPaymentsRequest): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.dealId === null || requestParameters.dealId === undefined) {
            throw new runtime.RequiredError('dealId','Required parameter requestParameters.dealId was null or undefined when calling exportXmlPurposesPayments.');
        }

        if (requestParameters.exportPaymentOrderSerilizer === null || requestParameters.exportPaymentOrderSerilizer === undefined) {
            throw new runtime.RequiredError('exportPaymentOrderSerilizer','Required parameter requestParameters.exportPaymentOrderSerilizer was null or undefined when calling exportXmlPurposesPayments.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/deals/{dealId}/purposes/payments/`.replace(`{${"dealId"}}`, encodeURIComponent(String(requestParameters.dealId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.exportPaymentOrderSerilizer.map(ExportPaymentOrderSerilizerToJSON),
        });

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Create XML file. File contents payment orders generated from Purposes objects.
     */
    async exportXmlPurposesPayments(requestParameters: ExportXmlPurposesPaymentsRequest): Promise<Blob> {
        const response = await this.exportXmlPurposesPaymentsRaw(requestParameters);
        return await response.value();
    }

    /**
     * This method return lead and form objects data. But, because we can find Form object in database only based on deal object primary key we have to add this method into DealViewSet in order to properly generation of OpenAPI schema.
     */
    async getApplicationFormRaw(requestParameters: GetApplicationFormRequest): Promise<runtime.ApiResponse<ApplicationForm>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getApplicationForm.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/deals/{id}/application_form/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ApplicationFormFromJSON(jsonValue));
    }

    /**
     * This method return lead and form objects data. But, because we can find Form object in database only based on deal object primary key we have to add this method into DealViewSet in order to properly generation of OpenAPI schema.
     */
    async getApplicationForm(requestParameters: GetApplicationFormRequest): Promise<ApplicationForm> {
        const response = await this.getApplicationFormRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async getClaimsStatementRaw(requestParameters: GetClaimsStatementRequest): Promise<runtime.ApiResponse<ClaimsStatement>> {
        if (requestParameters.dealId === null || requestParameters.dealId === undefined) {
            throw new runtime.RequiredError('dealId','Required parameter requestParameters.dealId was null or undefined when calling getClaimsStatement.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getClaimsStatement.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/deals/{dealId}/claims-statements/{id}/`.replace(`{${"dealId"}}`, encodeURIComponent(String(requestParameters.dealId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimsStatementFromJSON(jsonValue));
    }

    /**
     */
    async getClaimsStatement(requestParameters: GetClaimsStatementRequest): Promise<ClaimsStatement> {
        const response = await this.getClaimsStatementRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async getDealRaw(requestParameters: GetDealRequest): Promise<runtime.ApiResponse<Deal>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getDeal.');
        }

        const queryParameters: any = {};

        if (requestParameters.expand !== undefined) {
            queryParameters['expand'] = requestParameters.expand;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/deals/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => DealFromJSON(jsonValue));
    }

    /**
     */
    async getDeal(requestParameters: GetDealRequest): Promise<Deal> {
        const response = await this.getDealRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async getLabelRaw(requestParameters: GetLabelRequest): Promise<runtime.ApiResponse<Label>> {
        if (requestParameters.dealId === null || requestParameters.dealId === undefined) {
            throw new runtime.RequiredError('dealId','Required parameter requestParameters.dealId was null or undefined when calling getLabel.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getLabel.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/deals/{dealId}/label/{id}/`.replace(`{${"dealId"}}`, encodeURIComponent(String(requestParameters.dealId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => LabelFromJSON(jsonValue));
    }

    /**
     */
    async getLabel(requestParameters: GetLabelRequest): Promise<Label> {
        const response = await this.getLabelRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async getObligationRaw(requestParameters: GetObligationRequest): Promise<runtime.ApiResponse<Obligations>> {
        if (requestParameters.dealId === null || requestParameters.dealId === undefined) {
            throw new runtime.RequiredError('dealId','Required parameter requestParameters.dealId was null or undefined when calling getObligation.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getObligation.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/deals/{dealId}/obligations/{id}/`.replace(`{${"dealId"}}`, encodeURIComponent(String(requestParameters.dealId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObligationsFromJSON(jsonValue));
    }

    /**
     */
    async getObligation(requestParameters: GetObligationRequest): Promise<Obligations> {
        const response = await this.getObligationRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async listClaimsRaw(requestParameters: ListClaimsRequest): Promise<runtime.ApiResponse<Array<Claims>>> {
        if (requestParameters.dealId === null || requestParameters.dealId === undefined) {
            throw new runtime.RequiredError('dealId','Required parameter requestParameters.dealId was null or undefined when calling listClaims.');
        }

        const queryParameters: any = {};

        if (requestParameters.creditor !== undefined) {
            queryParameters['creditor'] = requestParameters.creditor;
        }

        if (requestParameters.dateFrom !== undefined) {
            queryParameters['date_from'] = (requestParameters.dateFrom as any).toISOString().substr(0,10);
        }

        if (requestParameters.dateTo !== undefined) {
            queryParameters['date_to'] = (requestParameters.dateTo as any).toISOString().substr(0,10);
        }

        if (requestParameters.ordering !== undefined) {
            queryParameters['ordering'] = requestParameters.ordering;
        }

        if (requestParameters.type !== undefined) {
            queryParameters['type'] = requestParameters.type;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/deals/{dealId}/claims/`.replace(`{${"dealId"}}`, encodeURIComponent(String(requestParameters.dealId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ClaimsFromJSON));
    }

    /**
     */
    async listClaims(requestParameters: ListClaimsRequest): Promise<Array<Claims>> {
        const response = await this.listClaimsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async listClaimsGroupLeaseRaw(requestParameters: ListClaimsGroupLeaseRequest): Promise<runtime.ApiResponse<Array<ClaimsGroupLease>>> {
        if (requestParameters.dealId === null || requestParameters.dealId === undefined) {
            throw new runtime.RequiredError('dealId','Required parameter requestParameters.dealId was null or undefined when calling listClaimsGroupLease.');
        }

        const queryParameters: any = {};

        if (requestParameters.ordering !== undefined) {
            queryParameters['ordering'] = requestParameters.ordering;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/deals/{dealId}/claims-group-lease/`.replace(`{${"dealId"}}`, encodeURIComponent(String(requestParameters.dealId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ClaimsGroupLeaseFromJSON));
    }

    /**
     */
    async listClaimsGroupLease(requestParameters: ListClaimsGroupLeaseRequest): Promise<Array<ClaimsGroupLease>> {
        const response = await this.listClaimsGroupLeaseRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async listClaimsGroupLeasebackRaw(requestParameters: ListClaimsGroupLeasebackRequest): Promise<runtime.ApiResponse<Array<ClaimsGroupLeaseback>>> {
        if (requestParameters.dealId === null || requestParameters.dealId === undefined) {
            throw new runtime.RequiredError('dealId','Required parameter requestParameters.dealId was null or undefined when calling listClaimsGroupLeaseback.');
        }

        const queryParameters: any = {};

        if (requestParameters.ordering !== undefined) {
            queryParameters['ordering'] = requestParameters.ordering;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/deals/{dealId}/claims-group-leaseback/`.replace(`{${"dealId"}}`, encodeURIComponent(String(requestParameters.dealId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ClaimsGroupLeasebackFromJSON));
    }

    /**
     */
    async listClaimsGroupLeaseback(requestParameters: ListClaimsGroupLeasebackRequest): Promise<Array<ClaimsGroupLeaseback>> {
        const response = await this.listClaimsGroupLeasebackRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async listClaimsGroupsRaw(requestParameters: ListClaimsGroupsRequest): Promise<runtime.ApiResponse<Array<ClaimsGroup>>> {
        if (requestParameters.dealId === null || requestParameters.dealId === undefined) {
            throw new runtime.RequiredError('dealId','Required parameter requestParameters.dealId was null or undefined when calling listClaimsGroups.');
        }

        const queryParameters: any = {};

        if (requestParameters.ordering !== undefined) {
            queryParameters['ordering'] = requestParameters.ordering;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/deals/{dealId}/claims-group/`.replace(`{${"dealId"}}`, encodeURIComponent(String(requestParameters.dealId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ClaimsGroupFromJSON));
    }

    /**
     */
    async listClaimsGroups(requestParameters: ListClaimsGroupsRequest): Promise<Array<ClaimsGroup>> {
        const response = await this.listClaimsGroupsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async listClaimsSettingsRaw(requestParameters: ListClaimsSettingsRequest): Promise<runtime.ApiResponse<Array<ClaimsSettings>>> {
        if (requestParameters.dealId === null || requestParameters.dealId === undefined) {
            throw new runtime.RequiredError('dealId','Required parameter requestParameters.dealId was null or undefined when calling listClaimsSettings.');
        }

        const queryParameters: any = {};

        if (requestParameters.ordering !== undefined) {
            queryParameters['ordering'] = requestParameters.ordering;
        }

        if (requestParameters.type !== undefined) {
            queryParameters['type'] = requestParameters.type;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/deals/{dealId}/claims-settings/`.replace(`{${"dealId"}}`, encodeURIComponent(String(requestParameters.dealId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ClaimsSettingsFromJSON));
    }

    /**
     */
    async listClaimsSettings(requestParameters: ListClaimsSettingsRequest): Promise<Array<ClaimsSettings>> {
        const response = await this.listClaimsSettingsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async listClaimsStatementsRaw(requestParameters: ListClaimsStatementsRequest): Promise<runtime.ApiResponse<Array<ClaimsStatement>>> {
        if (requestParameters.dealId === null || requestParameters.dealId === undefined) {
            throw new runtime.RequiredError('dealId','Required parameter requestParameters.dealId was null or undefined when calling listClaimsStatements.');
        }

        const queryParameters: any = {};

        if (requestParameters.ordering !== undefined) {
            queryParameters['ordering'] = requestParameters.ordering;
        }

        if (requestParameters.state !== undefined) {
            queryParameters['state'] = requestParameters.state;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/deals/{dealId}/claims-statements/`.replace(`{${"dealId"}}`, encodeURIComponent(String(requestParameters.dealId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ClaimsStatementFromJSON));
    }

    /**
     */
    async listClaimsStatements(requestParameters: ListClaimsStatementsRequest): Promise<Array<ClaimsStatement>> {
        const response = await this.listClaimsStatementsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get list of notes for appropriate deal
     */
    async listDealNotesRaw(requestParameters: ListDealNotesRequest): Promise<runtime.ApiResponse<Array<Note>>> {
        if (requestParameters.dealId === null || requestParameters.dealId === undefined) {
            throw new runtime.RequiredError('dealId','Required parameter requestParameters.dealId was null or undefined when calling listDealNotes.');
        }

        const queryParameters: any = {};

        if (requestParameters.ordering !== undefined) {
            queryParameters['ordering'] = requestParameters.ordering;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/deals/{dealId}/notes/`.replace(`{${"dealId"}}`, encodeURIComponent(String(requestParameters.dealId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(NoteFromJSON));
    }

    /**
     * Get list of notes for appropriate deal
     */
    async listDealNotes(requestParameters: ListDealNotesRequest): Promise<Array<Note>> {
        const response = await this.listDealNotesRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async listDealObligationsRaw(requestParameters: ListDealObligationsRequest): Promise<runtime.ApiResponse<Array<Obligations>>> {
        if (requestParameters.dealId === null || requestParameters.dealId === undefined) {
            throw new runtime.RequiredError('dealId','Required parameter requestParameters.dealId was null or undefined when calling listDealObligations.');
        }

        const queryParameters: any = {};

        if (requestParameters.ordering !== undefined) {
            queryParameters['ordering'] = requestParameters.ordering;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/deals/{dealId}/obligations/`.replace(`{${"dealId"}}`, encodeURIComponent(String(requestParameters.dealId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ObligationsFromJSON));
    }

    /**
     */
    async listDealObligations(requestParameters: ListDealObligationsRequest): Promise<Array<Obligations>> {
        const response = await this.listDealObligationsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async listDealPaymentsRaw(requestParameters: ListDealPaymentsRequest): Promise<runtime.ApiResponse<PaginatedPaymentList>> {
        if (requestParameters.dealId === null || requestParameters.dealId === undefined) {
            throw new runtime.RequiredError('dealId','Required parameter requestParameters.dealId was null or undefined when calling listDealPayments.');
        }

        const queryParameters: any = {};

        if (requestParameters.dateFrom !== undefined) {
            queryParameters['date_from'] = (requestParameters.dateFrom as any).toISOString().substr(0,10);
        }

        if (requestParameters.dateTo !== undefined) {
            queryParameters['date_to'] = (requestParameters.dateTo as any).toISOString().substr(0,10);
        }

        if (requestParameters.ordering !== undefined) {
            queryParameters['ordering'] = requestParameters.ordering;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['page_size'] = requestParameters.pageSize;
        }

        if (requestParameters.paymentType !== undefined) {
            queryParameters['payment_type'] = requestParameters.paymentType;
        }

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/deals/{dealId}/payments/`.replace(`{${"dealId"}}`, encodeURIComponent(String(requestParameters.dealId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedPaymentListFromJSON(jsonValue));
    }

    /**
     */
    async listDealPayments(requestParameters: ListDealPaymentsRequest): Promise<PaginatedPaymentList> {
        const response = await this.listDealPaymentsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async listDealPurposesRaw(requestParameters: ListDealPurposesRequest): Promise<runtime.ApiResponse<Array<Purpose>>> {
        if (requestParameters.dealId === null || requestParameters.dealId === undefined) {
            throw new runtime.RequiredError('dealId','Required parameter requestParameters.dealId was null or undefined when calling listDealPurposes.');
        }

        const queryParameters: any = {};

        if (requestParameters.ordering !== undefined) {
            queryParameters['ordering'] = requestParameters.ordering;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/deals/{dealId}/purposes/`.replace(`{${"dealId"}}`, encodeURIComponent(String(requestParameters.dealId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PurposeFromJSON));
    }

    /**
     */
    async listDealPurposes(requestParameters: ListDealPurposesRequest): Promise<Array<Purpose>> {
        const response = await this.listDealPurposesRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async listDealRealtiesRaw(requestParameters: ListDealRealtiesRequest): Promise<runtime.ApiResponse<Array<Realty>>> {
        if (requestParameters.dealId === null || requestParameters.dealId === undefined) {
            throw new runtime.RequiredError('dealId','Required parameter requestParameters.dealId was null or undefined when calling listDealRealties.');
        }

        const queryParameters: any = {};

        if (requestParameters.ordering !== undefined) {
            queryParameters['ordering'] = requestParameters.ordering;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/deals/{dealId}/realties/`.replace(`{${"dealId"}}`, encodeURIComponent(String(requestParameters.dealId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(RealtyFromJSON));
    }

    /**
     */
    async listDealRealties(requestParameters: ListDealRealtiesRequest): Promise<Array<Realty>> {
        const response = await this.listDealRealtiesRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async listDealRealtyGroupsRaw(requestParameters: ListDealRealtyGroupsRequest): Promise<runtime.ApiResponse<Array<DealRealtyGroup>>> {
        if (requestParameters.dealId === null || requestParameters.dealId === undefined) {
            throw new runtime.RequiredError('dealId','Required parameter requestParameters.dealId was null or undefined when calling listDealRealtyGroups.');
        }

        const queryParameters: any = {};

        if (requestParameters.mortgage !== undefined) {
            queryParameters['mortgage'] = requestParameters.mortgage;
        }

        if (requestParameters.ordering !== undefined) {
            queryParameters['ordering'] = requestParameters.ordering;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/deals/{dealId}/realty-groups/`.replace(`{${"dealId"}}`, encodeURIComponent(String(requestParameters.dealId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DealRealtyGroupFromJSON));
    }

    /**
     */
    async listDealRealtyGroups(requestParameters: ListDealRealtyGroupsRequest): Promise<Array<DealRealtyGroup>> {
        const response = await this.listDealRealtyGroupsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async listDealsRaw(requestParameters: ListDealsRequest): Promise<runtime.ApiResponse<PaginatedDealsListList>> {
        const queryParameters: any = {};

        if (requestParameters.breachType) {
            queryParameters['breach_type'] = requestParameters.breachType;
        }

        if (requestParameters.closedReason) {
            queryParameters['closed_reason'] = requestParameters.closedReason;
        }

        if (requestParameters.daysPastDue !== undefined) {
            queryParameters['days_past_due'] = requestParameters.daysPastDue;
        }

        if (requestParameters.externalId) {
            queryParameters['external_id'] = requestParameters.externalId.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters.id !== undefined) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.insolvency !== undefined) {
            queryParameters['insolvency'] = requestParameters.insolvency;
        }

        if (requestParameters.liquidated !== undefined) {
            queryParameters['liquidated'] = requestParameters.liquidated;
        }

        if (requestParameters.ordering !== undefined) {
            queryParameters['ordering'] = requestParameters.ordering;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['page_size'] = requestParameters.pageSize;
        }

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        if (requestParameters.settingsOff) {
            queryParameters['settings_off'] = requestParameters.settingsOff;
        }

        if (requestParameters.settingsOn) {
            queryParameters['settings_on'] = requestParameters.settingsOn;
        }

        if (requestParameters.state) {
            queryParameters['state'] = requestParameters.state;
        }

        if (requestParameters.type) {
            queryParameters['type'] = requestParameters.type;
        }

        if (requestParameters.valueFrom !== undefined) {
            queryParameters['value_from'] = requestParameters.valueFrom;
        }

        if (requestParameters.valueTo !== undefined) {
            queryParameters['value_to'] = requestParameters.valueTo;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/deals/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedDealsListListFromJSON(jsonValue));
    }

    /**
     */
    async listDeals(requestParameters: ListDealsRequest): Promise<PaginatedDealsListList> {
        const response = await this.listDealsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async listDealsParticipantsRaw(requestParameters: ListDealsParticipantsRequest): Promise<runtime.ApiResponse<Array<Participant>>> {
        if (requestParameters.dealId === null || requestParameters.dealId === undefined) {
            throw new runtime.RequiredError('dealId','Required parameter requestParameters.dealId was null or undefined when calling listDealsParticipants.');
        }

        const queryParameters: any = {};

        if (requestParameters.ordering !== undefined) {
            queryParameters['ordering'] = requestParameters.ordering;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/deals/{dealId}/participants/`.replace(`{${"dealId"}}`, encodeURIComponent(String(requestParameters.dealId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ParticipantFromJSON));
    }

    /**
     */
    async listDealsParticipants(requestParameters: ListDealsParticipantsRequest): Promise<Array<Participant>> {
        const response = await this.listDealsParticipantsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async listLabelsRaw(requestParameters: ListLabelsRequest): Promise<runtime.ApiResponse<Array<Label>>> {
        if (requestParameters.dealId === null || requestParameters.dealId === undefined) {
            throw new runtime.RequiredError('dealId','Required parameter requestParameters.dealId was null or undefined when calling listLabels.');
        }

        const queryParameters: any = {};

        if (requestParameters.ordering !== undefined) {
            queryParameters['ordering'] = requestParameters.ordering;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/deals/{dealId}/label/`.replace(`{${"dealId"}}`, encodeURIComponent(String(requestParameters.dealId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(LabelFromJSON));
    }

    /**
     */
    async listLabels(requestParameters: ListLabelsRequest): Promise<Array<Label>> {
        const response = await this.listLabelsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async listNoticeGroupsRaw(requestParameters: ListNoticeGroupsRequest): Promise<runtime.ApiResponse<Array<NoticeGroup>>> {
        if (requestParameters.dealId === null || requestParameters.dealId === undefined) {
            throw new runtime.RequiredError('dealId','Required parameter requestParameters.dealId was null or undefined when calling listNoticeGroups.');
        }

        const queryParameters: any = {};

        if (requestParameters.ordering !== undefined) {
            queryParameters['ordering'] = requestParameters.ordering;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/deals/{dealId}/notice-groups/`.replace(`{${"dealId"}}`, encodeURIComponent(String(requestParameters.dealId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(NoticeGroupFromJSON));
    }

    /**
     */
    async listNoticeGroups(requestParameters: ListNoticeGroupsRequest): Promise<Array<NoticeGroup>> {
        const response = await this.listNoticeGroupsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async partialUpdateClaimsRaw(requestParameters: PartialUpdateClaimsRequest): Promise<runtime.ApiResponse<Claims>> {
        if (requestParameters.dealId === null || requestParameters.dealId === undefined) {
            throw new runtime.RequiredError('dealId','Required parameter requestParameters.dealId was null or undefined when calling partialUpdateClaims.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling partialUpdateClaims.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/deals/{dealId}/claims/{id}/`.replace(`{${"dealId"}}`, encodeURIComponent(String(requestParameters.dealId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchedClaimsToJSON(requestParameters.patchedClaims),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimsFromJSON(jsonValue));
    }

    /**
     */
    async partialUpdateClaims(requestParameters: PartialUpdateClaimsRequest): Promise<Claims> {
        const response = await this.partialUpdateClaimsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async partialUpdateClaimsGroupRaw(requestParameters: PartialUpdateClaimsGroupRequest): Promise<runtime.ApiResponse<ClaimsGroup>> {
        if (requestParameters.dealId === null || requestParameters.dealId === undefined) {
            throw new runtime.RequiredError('dealId','Required parameter requestParameters.dealId was null or undefined when calling partialUpdateClaimsGroup.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling partialUpdateClaimsGroup.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/deals/{dealId}/claims-group/{id}/`.replace(`{${"dealId"}}`, encodeURIComponent(String(requestParameters.dealId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchedClaimsGroupToJSON(requestParameters.patchedClaimsGroup),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimsGroupFromJSON(jsonValue));
    }

    /**
     */
    async partialUpdateClaimsGroup(requestParameters: PartialUpdateClaimsGroupRequest): Promise<ClaimsGroup> {
        const response = await this.partialUpdateClaimsGroupRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async partialUpdateClaimsGroupLeaseRaw(requestParameters: PartialUpdateClaimsGroupLeaseRequest): Promise<runtime.ApiResponse<ClaimsGroupLease>> {
        if (requestParameters.dealId === null || requestParameters.dealId === undefined) {
            throw new runtime.RequiredError('dealId','Required parameter requestParameters.dealId was null or undefined when calling partialUpdateClaimsGroupLease.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling partialUpdateClaimsGroupLease.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/deals/{dealId}/claims-group-lease/{id}/`.replace(`{${"dealId"}}`, encodeURIComponent(String(requestParameters.dealId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchedClaimsGroupLeaseToJSON(requestParameters.patchedClaimsGroupLease),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimsGroupLeaseFromJSON(jsonValue));
    }

    /**
     */
    async partialUpdateClaimsGroupLease(requestParameters: PartialUpdateClaimsGroupLeaseRequest): Promise<ClaimsGroupLease> {
        const response = await this.partialUpdateClaimsGroupLeaseRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async partialUpdateClaimsGroupLeasebackRaw(requestParameters: PartialUpdateClaimsGroupLeasebackRequest): Promise<runtime.ApiResponse<ClaimsGroupLeaseback>> {
        if (requestParameters.dealId === null || requestParameters.dealId === undefined) {
            throw new runtime.RequiredError('dealId','Required parameter requestParameters.dealId was null or undefined when calling partialUpdateClaimsGroupLeaseback.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling partialUpdateClaimsGroupLeaseback.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/deals/{dealId}/claims-group-leaseback/{id}/`.replace(`{${"dealId"}}`, encodeURIComponent(String(requestParameters.dealId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchedClaimsGroupLeasebackToJSON(requestParameters.patchedClaimsGroupLeaseback),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimsGroupLeasebackFromJSON(jsonValue));
    }

    /**
     */
    async partialUpdateClaimsGroupLeaseback(requestParameters: PartialUpdateClaimsGroupLeasebackRequest): Promise<ClaimsGroupLeaseback> {
        const response = await this.partialUpdateClaimsGroupLeasebackRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async partialUpdateClaimsStatementRaw(requestParameters: PartialUpdateClaimsStatementRequest): Promise<runtime.ApiResponse<ClaimsStatement>> {
        if (requestParameters.dealId === null || requestParameters.dealId === undefined) {
            throw new runtime.RequiredError('dealId','Required parameter requestParameters.dealId was null or undefined when calling partialUpdateClaimsStatement.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling partialUpdateClaimsStatement.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/deals/{dealId}/claims-statements/{id}/`.replace(`{${"dealId"}}`, encodeURIComponent(String(requestParameters.dealId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchedUpdateClaimsStatementToJSON(requestParameters.patchedUpdateClaimsStatement),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimsStatementFromJSON(jsonValue));
    }

    /**
     */
    async partialUpdateClaimsStatement(requestParameters: PartialUpdateClaimsStatementRequest): Promise<ClaimsStatement> {
        const response = await this.partialUpdateClaimsStatementRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async partialUpdateDealRaw(requestParameters: PartialUpdateDealRequest): Promise<runtime.ApiResponse<Deal>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling partialUpdateDeal.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/deals/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchedDealToJSON(requestParameters.patchedDeal),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => DealFromJSON(jsonValue));
    }

    /**
     */
    async partialUpdateDeal(requestParameters: PartialUpdateDealRequest): Promise<Deal> {
        const response = await this.partialUpdateDealRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async partialUpdateDealParticipantRaw(requestParameters: PartialUpdateDealParticipantRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.dealId === null || requestParameters.dealId === undefined) {
            throw new runtime.RequiredError('dealId','Required parameter requestParameters.dealId was null or undefined when calling partialUpdateDealParticipant.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling partialUpdateDealParticipant.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/deals/{dealId}/participants/{id}/`.replace(`{${"dealId"}}`, encodeURIComponent(String(requestParameters.dealId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchedParticipantToJSON(requestParameters.patchedParticipant),
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async partialUpdateDealParticipant(requestParameters: PartialUpdateDealParticipantRequest): Promise<void> {
        await this.partialUpdateDealParticipantRaw(requestParameters);
    }

    /**
     */
    async partialUpdateDealPurposesRaw(requestParameters: PartialUpdateDealPurposesRequest): Promise<runtime.ApiResponse<Purpose>> {
        if (requestParameters.dealId === null || requestParameters.dealId === undefined) {
            throw new runtime.RequiredError('dealId','Required parameter requestParameters.dealId was null or undefined when calling partialUpdateDealPurposes.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling partialUpdateDealPurposes.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/deals/{dealId}/purposes/{id}/`.replace(`{${"dealId"}}`, encodeURIComponent(String(requestParameters.dealId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchedPurposeToJSON(requestParameters.patchedPurpose),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => PurposeFromJSON(jsonValue));
    }

    /**
     */
    async partialUpdateDealPurposes(requestParameters: PartialUpdateDealPurposesRequest): Promise<Purpose> {
        const response = await this.partialUpdateDealPurposesRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async partialUpdateDealRealtyGroupRaw(requestParameters: PartialUpdateDealRealtyGroupRequest): Promise<runtime.ApiResponse<DealRealtyGroupUpdate>> {
        if (requestParameters.dealId === null || requestParameters.dealId === undefined) {
            throw new runtime.RequiredError('dealId','Required parameter requestParameters.dealId was null or undefined when calling partialUpdateDealRealtyGroup.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling partialUpdateDealRealtyGroup.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/deals/{dealId}/realty-groups/{id}/`.replace(`{${"dealId"}}`, encodeURIComponent(String(requestParameters.dealId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchedDealRealtyGroupUpdateToJSON(requestParameters.patchedDealRealtyGroupUpdate),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => DealRealtyGroupUpdateFromJSON(jsonValue));
    }

    /**
     */
    async partialUpdateDealRealtyGroup(requestParameters: PartialUpdateDealRealtyGroupRequest): Promise<DealRealtyGroupUpdate> {
        const response = await this.partialUpdateDealRealtyGroupRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async partialUpdateObligationRaw(requestParameters: PartialUpdateObligationRequest): Promise<runtime.ApiResponse<Obligations>> {
        if (requestParameters.dealId === null || requestParameters.dealId === undefined) {
            throw new runtime.RequiredError('dealId','Required parameter requestParameters.dealId was null or undefined when calling partialUpdateObligation.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling partialUpdateObligation.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/deals/{dealId}/obligations/{id}/`.replace(`{${"dealId"}}`, encodeURIComponent(String(requestParameters.dealId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchedObligationsToJSON(requestParameters.patchedObligations),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObligationsFromJSON(jsonValue));
    }

    /**
     */
    async partialUpdateObligation(requestParameters: PartialUpdateObligationRequest): Promise<Obligations> {
        const response = await this.partialUpdateObligationRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async partialUpdatePurposeDrawingRaw(requestParameters: PartialUpdatePurposeDrawingRequest): Promise<runtime.ApiResponse<PurposeDrawing>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling partialUpdatePurposeDrawing.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/deals/purpose/purpose-drawing/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchedPurposeDrawingToJSON(requestParameters.patchedPurposeDrawing),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => PurposeDrawingFromJSON(jsonValue));
    }

    /**
     */
    async partialUpdatePurposeDrawing(requestParameters: PartialUpdatePurposeDrawingRequest): Promise<PurposeDrawing> {
        const response = await this.partialUpdatePurposeDrawingRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async saveClaimsStatementRaw(requestParameters: SaveClaimsStatementRequest): Promise<runtime.ApiResponse<ClaimsStatement>> {
        if (requestParameters.dealId === null || requestParameters.dealId === undefined) {
            throw new runtime.RequiredError('dealId','Required parameter requestParameters.dealId was null or undefined when calling saveClaimsStatement.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling saveClaimsStatement.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/deals/{dealId}/claims-statements/{id}/save/`.replace(`{${"dealId"}}`, encodeURIComponent(String(requestParameters.dealId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SaveClaimsStatementToJSON(requestParameters.saveClaimsStatement),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimsStatementFromJSON(jsonValue));
    }

    /**
     */
    async saveClaimsStatement(requestParameters: SaveClaimsStatementRequest): Promise<ClaimsStatement> {
        const response = await this.saveClaimsStatementRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async sendNoticesRaw(requestParameters: SendNoticesRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.dealId === null || requestParameters.dealId === undefined) {
            throw new runtime.RequiredError('dealId','Required parameter requestParameters.dealId was null or undefined when calling sendNotices.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling sendNotices.');
        }

        if (requestParameters.noticeGroup === null || requestParameters.noticeGroup === undefined) {
            throw new runtime.RequiredError('noticeGroup','Required parameter requestParameters.noticeGroup was null or undefined when calling sendNotices.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/deals/{dealId}/notice-groups/{id}/send_notices/`.replace(`{${"dealId"}}`, encodeURIComponent(String(requestParameters.dealId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NoticeGroupToJSON(requestParameters.noticeGroup),
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async sendNotices(requestParameters: SendNoticesRequest): Promise<void> {
        await this.sendNoticesRaw(requestParameters);
    }

    /**
     */
    async updateClaimsRaw(requestParameters: UpdateClaimsRequest): Promise<runtime.ApiResponse<Claims>> {
        if (requestParameters.dealId === null || requestParameters.dealId === undefined) {
            throw new runtime.RequiredError('dealId','Required parameter requestParameters.dealId was null or undefined when calling updateClaims.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateClaims.');
        }

        if (requestParameters.claims === null || requestParameters.claims === undefined) {
            throw new runtime.RequiredError('claims','Required parameter requestParameters.claims was null or undefined when calling updateClaims.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/deals/{dealId}/claims/{id}/`.replace(`{${"dealId"}}`, encodeURIComponent(String(requestParameters.dealId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ClaimsToJSON(requestParameters.claims),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimsFromJSON(jsonValue));
    }

    /**
     */
    async updateClaims(requestParameters: UpdateClaimsRequest): Promise<Claims> {
        const response = await this.updateClaimsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async updateClaimsGroupRaw(requestParameters: UpdateClaimsGroupRequest): Promise<runtime.ApiResponse<ClaimsGroup>> {
        if (requestParameters.dealId === null || requestParameters.dealId === undefined) {
            throw new runtime.RequiredError('dealId','Required parameter requestParameters.dealId was null or undefined when calling updateClaimsGroup.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateClaimsGroup.');
        }

        if (requestParameters.claimsGroup === null || requestParameters.claimsGroup === undefined) {
            throw new runtime.RequiredError('claimsGroup','Required parameter requestParameters.claimsGroup was null or undefined when calling updateClaimsGroup.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/deals/{dealId}/claims-group/{id}/`.replace(`{${"dealId"}}`, encodeURIComponent(String(requestParameters.dealId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ClaimsGroupToJSON(requestParameters.claimsGroup),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimsGroupFromJSON(jsonValue));
    }

    /**
     */
    async updateClaimsGroup(requestParameters: UpdateClaimsGroupRequest): Promise<ClaimsGroup> {
        const response = await this.updateClaimsGroupRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async updateClaimsGroupLeaseRaw(requestParameters: UpdateClaimsGroupLeaseRequest): Promise<runtime.ApiResponse<ClaimsGroupLease>> {
        if (requestParameters.dealId === null || requestParameters.dealId === undefined) {
            throw new runtime.RequiredError('dealId','Required parameter requestParameters.dealId was null or undefined when calling updateClaimsGroupLease.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateClaimsGroupLease.');
        }

        if (requestParameters.claimsGroupLease === null || requestParameters.claimsGroupLease === undefined) {
            throw new runtime.RequiredError('claimsGroupLease','Required parameter requestParameters.claimsGroupLease was null or undefined when calling updateClaimsGroupLease.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/deals/{dealId}/claims-group-lease/{id}/`.replace(`{${"dealId"}}`, encodeURIComponent(String(requestParameters.dealId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ClaimsGroupLeaseToJSON(requestParameters.claimsGroupLease),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimsGroupLeaseFromJSON(jsonValue));
    }

    /**
     */
    async updateClaimsGroupLease(requestParameters: UpdateClaimsGroupLeaseRequest): Promise<ClaimsGroupLease> {
        const response = await this.updateClaimsGroupLeaseRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async updateClaimsGroupLeasebackRaw(requestParameters: UpdateClaimsGroupLeasebackRequest): Promise<runtime.ApiResponse<ClaimsGroupLeaseback>> {
        if (requestParameters.dealId === null || requestParameters.dealId === undefined) {
            throw new runtime.RequiredError('dealId','Required parameter requestParameters.dealId was null or undefined when calling updateClaimsGroupLeaseback.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateClaimsGroupLeaseback.');
        }

        if (requestParameters.claimsGroupLeaseback === null || requestParameters.claimsGroupLeaseback === undefined) {
            throw new runtime.RequiredError('claimsGroupLeaseback','Required parameter requestParameters.claimsGroupLeaseback was null or undefined when calling updateClaimsGroupLeaseback.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/deals/{dealId}/claims-group-leaseback/{id}/`.replace(`{${"dealId"}}`, encodeURIComponent(String(requestParameters.dealId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ClaimsGroupLeasebackToJSON(requestParameters.claimsGroupLeaseback),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimsGroupLeasebackFromJSON(jsonValue));
    }

    /**
     */
    async updateClaimsGroupLeaseback(requestParameters: UpdateClaimsGroupLeasebackRequest): Promise<ClaimsGroupLeaseback> {
        const response = await this.updateClaimsGroupLeasebackRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async updateClaimsStatementRaw(requestParameters: UpdateClaimsStatementRequest): Promise<runtime.ApiResponse<ClaimsStatement>> {
        if (requestParameters.dealId === null || requestParameters.dealId === undefined) {
            throw new runtime.RequiredError('dealId','Required parameter requestParameters.dealId was null or undefined when calling updateClaimsStatement.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateClaimsStatement.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/deals/{dealId}/claims-statements/{id}/`.replace(`{${"dealId"}}`, encodeURIComponent(String(requestParameters.dealId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateClaimsStatementToJSON(requestParameters.updateClaimsStatement),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimsStatementFromJSON(jsonValue));
    }

    /**
     */
    async updateClaimsStatement(requestParameters: UpdateClaimsStatementRequest): Promise<ClaimsStatement> {
        const response = await this.updateClaimsStatementRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async updateDealRaw(requestParameters: UpdateDealRequest): Promise<runtime.ApiResponse<Deal>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateDeal.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/deals/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: DealToJSON(requestParameters.deal),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => DealFromJSON(jsonValue));
    }

    /**
     */
    async updateDeal(requestParameters: UpdateDealRequest): Promise<Deal> {
        const response = await this.updateDealRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async updateDealParticipantRaw(requestParameters: UpdateDealParticipantRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.dealId === null || requestParameters.dealId === undefined) {
            throw new runtime.RequiredError('dealId','Required parameter requestParameters.dealId was null or undefined when calling updateDealParticipant.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateDealParticipant.');
        }

        if (requestParameters.participant === null || requestParameters.participant === undefined) {
            throw new runtime.RequiredError('participant','Required parameter requestParameters.participant was null or undefined when calling updateDealParticipant.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/deals/{dealId}/participants/{id}/`.replace(`{${"dealId"}}`, encodeURIComponent(String(requestParameters.dealId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ParticipantToJSON(requestParameters.participant),
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateDealParticipant(requestParameters: UpdateDealParticipantRequest): Promise<void> {
        await this.updateDealParticipantRaw(requestParameters);
    }

    /**
     */
    async updateDealPurposesRaw(requestParameters: UpdateDealPurposesRequest): Promise<runtime.ApiResponse<Purpose>> {
        if (requestParameters.dealId === null || requestParameters.dealId === undefined) {
            throw new runtime.RequiredError('dealId','Required parameter requestParameters.dealId was null or undefined when calling updateDealPurposes.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateDealPurposes.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/deals/{dealId}/purposes/{id}/`.replace(`{${"dealId"}}`, encodeURIComponent(String(requestParameters.dealId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: PurposeToJSON(requestParameters.purpose),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => PurposeFromJSON(jsonValue));
    }

    /**
     */
    async updateDealPurposes(requestParameters: UpdateDealPurposesRequest): Promise<Purpose> {
        const response = await this.updateDealPurposesRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async updateDealRealtyGroupRaw(requestParameters: UpdateDealRealtyGroupRequest): Promise<runtime.ApiResponse<DealRealtyGroupUpdate>> {
        if (requestParameters.dealId === null || requestParameters.dealId === undefined) {
            throw new runtime.RequiredError('dealId','Required parameter requestParameters.dealId was null or undefined when calling updateDealRealtyGroup.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateDealRealtyGroup.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/deals/{dealId}/realty-groups/{id}/`.replace(`{${"dealId"}}`, encodeURIComponent(String(requestParameters.dealId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: DealRealtyGroupUpdateToJSON(requestParameters.dealRealtyGroupUpdate),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => DealRealtyGroupUpdateFromJSON(jsonValue));
    }

    /**
     */
    async updateDealRealtyGroup(requestParameters: UpdateDealRealtyGroupRequest): Promise<DealRealtyGroupUpdate> {
        const response = await this.updateDealRealtyGroupRaw(requestParameters);
        return await response.value();
    }

    /**
     * attributes \"closed_application_reason\" and \"additional_data\": {\"closed_application_notification\": true/false} are required for \"CLOSED_APPLICATION\" state and deal types \"CONSUMER_LOAN\" and \"INVESTMENT_LOAN\", otherwise it is ignored.
     * Request for deal state change.
     */
    async updateDealStateRaw(requestParameters: UpdateDealStateRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateDealState.');
        }

        if (requestParameters.dealState === null || requestParameters.dealState === undefined) {
            throw new runtime.RequiredError('dealState','Required parameter requestParameters.dealState was null or undefined when calling updateDealState.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/deals/{id}/state/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DealStateToJSON(requestParameters.dealState),
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     * attributes \"closed_application_reason\" and \"additional_data\": {\"closed_application_notification\": true/false} are required for \"CLOSED_APPLICATION\" state and deal types \"CONSUMER_LOAN\" and \"INVESTMENT_LOAN\", otherwise it is ignored.
     * Request for deal state change.
     */
    async updateDealState(requestParameters: UpdateDealStateRequest): Promise<void> {
        await this.updateDealStateRaw(requestParameters);
    }

    /**
     */
    async updateNoticeGroupRaw(requestParameters: UpdateNoticeGroupRequest): Promise<runtime.ApiResponse<NoticeGroupUpdate>> {
        if (requestParameters.dealId === null || requestParameters.dealId === undefined) {
            throw new runtime.RequiredError('dealId','Required parameter requestParameters.dealId was null or undefined when calling updateNoticeGroup.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateNoticeGroup.');
        }

        if (requestParameters.noticeGroupUpdate === null || requestParameters.noticeGroupUpdate === undefined) {
            throw new runtime.RequiredError('noticeGroupUpdate','Required parameter requestParameters.noticeGroupUpdate was null or undefined when calling updateNoticeGroup.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/deals/{dealId}/notice-groups/{id}/`.replace(`{${"dealId"}}`, encodeURIComponent(String(requestParameters.dealId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: NoticeGroupUpdateToJSON(requestParameters.noticeGroupUpdate),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => NoticeGroupUpdateFromJSON(jsonValue));
    }

    /**
     */
    async updateNoticeGroup(requestParameters: UpdateNoticeGroupRequest): Promise<NoticeGroupUpdate> {
        const response = await this.updateNoticeGroupRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async updateObligationRaw(requestParameters: UpdateObligationRequest): Promise<runtime.ApiResponse<Obligations>> {
        if (requestParameters.dealId === null || requestParameters.dealId === undefined) {
            throw new runtime.RequiredError('dealId','Required parameter requestParameters.dealId was null or undefined when calling updateObligation.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateObligation.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/deals/{dealId}/obligations/{id}/`.replace(`{${"dealId"}}`, encodeURIComponent(String(requestParameters.dealId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ObligationsToJSON(requestParameters.obligations),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObligationsFromJSON(jsonValue));
    }

    /**
     */
    async updateObligation(requestParameters: UpdateObligationRequest): Promise<Obligations> {
        const response = await this.updateObligationRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async validateRaw(requestParameters: ValidateRequest): Promise<runtime.ApiResponse<Validation>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling validate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/deals/{id}/validate/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ValidationFromJSON(jsonValue));
    }

    /**
     */
    async validate(requestParameters: ValidateRequest): Promise<Validation> {
        const response = await this.validateRaw(requestParameters);
        return await response.value();
    }

}

/**
    * @export
    * @enum {string}
    */
export enum BreachesTypeDistinctListTypeEnum {
    NonPaying = 'NON_PAYING',
    UndeliveredBlockageAgreement = 'UNDELIVERED_BLOCKAGE_AGREEMENT',
    UndeliveredNotarialDeed = 'UNDELIVERED_NOTARIAL_DEED'
}
/**
    * @export
    * @enum {string}
    */
export enum DealBreachesListTypeEnum {
    NonPaying = 'NON_PAYING',
    UndeliveredBlockageAgreement = 'UNDELIVERED_BLOCKAGE_AGREEMENT',
    UndeliveredNotarialDeed = 'UNDELIVERED_NOTARIAL_DEED'
}
/**
    * @export
    * @enum {string}
    */
export enum ExportClaimsStatementAllocationProfileEnum {
    ClPeAllocationProfileV1 = 'CL_PE_ALLOCATION_PROFILE_V1',
    ClPeAllocationProfileV2 = 'CL_PE_ALLOCATION_PROFILE_V2',
    IlSeAllocationProfile = 'IL_SE_ALLOCATION_PROFILE',
    LoanAllocationProfileV1 = 'LOAN_ALLOCATION_PROFILE_V1',
    LoanAllocationProfileV2 = 'LOAN_ALLOCATION_PROFILE_V2',
    OtherProfileV1 = 'OTHER_PROFILE_V1'
}
/**
    * @export
    * @enum {string}
    */
export enum ListClaimsSettingsTypeEnum {
    BlockageAgreementNotice = 'DISABLE_BLOCKAGE_AGREEMENT_NOTICE',
    NonPayingNotice = 'DISABLE_NON_PAYING_NOTICE',
    NotarialDeedNotice = 'DISABLE_NOTARIAL_DEED_NOTICE'
}
/**
    * @export
    * @enum {string}
    */
export enum ListClaimsStatementsStateEnum {
    Draft = 'DRAFT',
    InProgress = 'IN_PROGRESS',
    NotValid = 'NOT_VALID',
    Saved = 'SAVED'
}
/**
    * @export
    * @enum {string}
    */
export enum ListDealsBreachTypeEnum {
    NonPaying = 'NON_PAYING',
    UndeliveredBlockageAgreement = 'UNDELIVERED_BLOCKAGE_AGREEMENT',
    UndeliveredIncomeTaxEvidence = 'UNDELIVERED_INCOME_TAX_EVIDENCE',
    UndeliveredNotarialDeed = 'UNDELIVERED_NOTARIAL_DEED',
    UndeliveredOtherDocuments = 'UNDELIVERED_OTHER_DOCUMENTS',
    UndeliveredThirdPartyEvidence = 'UNDELIVERED_THIRD_PARTY_EVIDENCE'
}
/**
    * @export
    * @enum {string}
    */
export enum ListDealsClosedReasonEnum {
    ClosedAfterInsolvency = 'CLOSED_AFTER_INSOLVENCY',
    ClosedAfterLiquidation = 'CLOSED_AFTER_LIQUIDATION',
    ClosedDealWriteOff = 'CLOSED_DEAL_WRITE_OFF',
    ClosedDebtorDeathNoSuccesor = 'CLOSED_DEBTOR_DEATH_NO_SUCCESOR',
    ClosedDuly = 'CLOSED_DULY',
    ClosedEnforcement = 'CLOSED_ENFORCEMENT',
    ClosedLeaseFinished = 'CLOSED_LEASE_FINISHED',
    ClosedLeaseForcedEviction = 'CLOSED_LEASE_FORCED_EVICTION',
    ClosedMovedToHc = 'CLOSED_MOVED_TO_HC',
    ClosedMovedToThirdParty = 'CLOSED_MOVED_TO_THIRD_PARTY',
    ClosedPrematurely = 'CLOSED_PREMATURELY',
    ClosedPropertyNotPurchased = 'CLOSED_PROPERTY_NOT_PURCHASED',
    ClosedPropertyPurchased = 'CLOSED_PROPERTY_PURCHASED',
    ClosedPropertySold = 'CLOSED_PROPERTY_SOLD',
    ClosedRefinanced = 'CLOSED_REFINANCED',
    Other = 'OTHER'
}
/**
    * @export
    * @enum {string}
    */
export enum ListDealsSettingsOffEnum {
    BlockageAgreementNotice = 'DISABLE_BLOCKAGE_AGREEMENT_NOTICE',
    NonPayingNotice = 'DISABLE_NON_PAYING_NOTICE',
    NotarialDeedNotice = 'DISABLE_NOTARIAL_DEED_NOTICE'
}
/**
    * @export
    * @enum {string}
    */
export enum ListDealsSettingsOnEnum {
    BlockageAgreementNotice = 'DISABLE_BLOCKAGE_AGREEMENT_NOTICE',
    NonPayingNotice = 'DISABLE_NON_PAYING_NOTICE',
    NotarialDeedNotice = 'DISABLE_NOTARIAL_DEED_NOTICE'
}
/**
    * @export
    * @enum {string}
    */
export enum ListDealsStateEnum {
    Active = 'ACTIVE',
    Closed = 'CLOSED',
    ClosedApplication = 'CLOSED_APPLICATION',
    ContractCompletion = 'CONTRACT_COMPLETION',
    ContractSign = 'CONTRACT_SIGN',
    FiledForInsolvency = 'FILED_FOR_INSOLVENCY',
    NewApplication = 'NEW_APPLICATION'
}
/**
    * @export
    * @enum {string}
    */
export enum ListDealsTypeEnum {
    Borrowing = 'BORROWING',
    ConsumerLoan = 'CONSUMER_LOAN',
    InvestmentLoan = 'INVESTMENT_LOAN',
    Lease = 'LEASE',
    Leasing = 'LEASING',
    OtherDeal = 'OTHER_DEAL',
    Sale = 'SALE',
    SaleAndLeaseback = 'SALE_AND_LEASEBACK'
}
